webpackJsonp([5],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResponsiveImage_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Testimonial_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_breadcrumb_breadcrumb__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_components_breadcrumb_breadcrumb_item__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components_layout_row__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_es_components_layout_col__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_es_components_carousel_carousel__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_vue_es_components_carousel_carousel_slide__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Helpers_Image_ts__ = __webpack_require__(55);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










var Cover = /** @class */ (function (_super) {
    __extends(Cover, _super);
    function Cover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.breadcrumbs = [];
        _this.randomTestimonials = undefined;
        _this.testimonial1 = null;
        _this.testimonial2 = null;
        _this.testimonialHandle = undefined;
        return _this;
    }
    Object.defineProperty(Cover.prototype, "hrVisible", {
        get: function () {
            if (this.showHr === true || this.showHr === false)
                return this.showHr;
            return this.shortDescription && this.longDescription;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Cover.prototype, "imagesArray", {
        get: function () {
            if (!this.images)
                return [];
            if (this.images instanceof Array)
                return this.images.map(function (p) { return Object(__WEBPACK_IMPORTED_MODULE_9__Helpers_Image_ts__["e" /* parseImageCropDataSet */])(p); });
            return [Object(__WEBPACK_IMPORTED_MODULE_9__Helpers_Image_ts__["e" /* parseImageCropDataSet */])(this.images)];
        },
        enumerable: true,
        configurable: true
    });
    Cover.prototype.mounted = function () {
        window.$bus.$on("BreadcrumbAnchor.mounted", this.refreshBreadcrumbs);
        window.$bus.$on("BreadcrumbAnchor.unmounted", this.refreshBreadcrumbs);
        this.refreshBreadcrumbs();
        this.setupTestimonials();
    };
    Cover.prototype.destroyed = function () {
        window.$bus.$off("BreadcrumbAnchor.mounted", this.refreshBreadcrumbs);
        window.$bus.$off("BreadcrumbAnchor.unmounted", this.refreshBreadcrumbs);
        if (this.testimonialHandle) {
            clearInterval(this.testimonialHandle);
        }
    };
    Cover.prototype.refreshBreadcrumbs = function () {
        this.breadcrumbs = this.$root.$el.querySelectorAll("[breadcrumb-title][id]");
    };
    Cover.prototype.carouselSliding = function () {
        this.transitionTestimonial();
    };
    Cover.prototype.setupTestimonials = function () {
        if (this.testimonials.length === 0)
            return;
        if (this.testimonials.length === 1) {
            this.testimonial1 = this.testimonials[0];
            return;
        }
        this.testimonial1 = this.getRandomTestimonial();
        // Only set up timer if there is not a carousel. Otherwise, transitions will be handled
        // by carousel events.
        //
        if (!this.$refs.carousel) {
            this.testimonialHandle = setInterval(this.transitionTestimonial.bind(this), 5000);
        }
    };
    Cover.prototype.transitionTestimonial = function () {
        if (this.testimonial1) {
            this.testimonial1 = null;
            this.testimonial2 = this.getRandomTestimonial();
        }
        else {
            this.testimonial2 = null;
            this.testimonial1 = this.getRandomTestimonial();
        }
    };
    Cover.prototype.getRandomTestimonial = function () {
        if (this.testimonials.length === 0)
            return null;
        if (this.testimonials.length === 1)
            return this.testimonials[0];
        if (!this.randomTestimonials || this.randomTestimonials.length === 0) {
            this.randomTestimonials = this.testimonials.shuffle();
        }
        return this.randomTestimonials.pop();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Cover.prototype, "title", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Cover.prototype, "shortDescription", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Cover.prototype, "longDescription", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Boolean, default: undefined })
    ], Cover.prototype, "showHr", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Array, default: function () { return []; } })
    ], Cover.prototype, "hashtags", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: [Array, String, Object], default: function () { return []; } })
    ], Cover.prototype, "images", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Array, default: function () { return []; } })
    ], Cover.prototype, "testimonials", void 0);
    Cover = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "Cover",
            components: {
                ResponsiveImage: __WEBPACK_IMPORTED_MODULE_1__ResponsiveImage_vue__["a" /* default */],
                Testimonial: __WEBPACK_IMPORTED_MODULE_2__Testimonial_vue__["a" /* default */],
                "b-row": __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components_layout_row__["a" /* default */],
                "b-col": __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_es_components_layout_col__["a" /* default */],
                "b-breadcrumb": __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_breadcrumb_breadcrumb__["a" /* default */],
                "b-breadcrumb-item": __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_components_breadcrumb_breadcrumb_item__["a" /* default */],
                "b-carousel": __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_es_components_carousel_carousel__["a" /* default */],
                "b-carousel-slide": __WEBPACK_IMPORTED_MODULE_8_bootstrap_vue_es_components_carousel_carousel_slide__["a" /* default */]
            }
        })
    ], Cover);
    return Cover;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Cover);
;


/***/ }),

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unPrefixPropName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lower_first__ = __webpack_require__(101);


/**
 * @param {string} prefix
 * @param {string} value
 */
function unPrefixPropName(prefix, value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lower_first__["a" /* default */])(value.replace(prefix, ''));
}

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lowerFirst;
/**
 * @param {string} str
 */
function lowerFirst(str) {
  if (typeof str !== 'string') {
    str = String(str);
  }
  return str.charAt(0).toLowerCase() + str.slice(1);
}

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_copyProps__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__ = __webpack_require__(52);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var props = Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_copyProps__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__["a" /* default */].props, __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__["a" /* default */].bind(null, 'body')), {
  bodyClass: {
    type: [String, Object, Array],
    default: null
  },
  title: {
    type: String,
    default: null
  },
  titleTag: {
    type: String,
    default: 'h4'
  },
  subTitle: {
    type: String,
    default: null
  },
  subTitleTag: {
    type: String,
    default: 'h6'
  },
  overlay: {
    type: Boolean,
    default: false
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _ref2;

    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots;

    var cardBodyChildren = [];
    if (props.title) {
      cardBodyChildren.push(h(props.titleTag, {
        staticClass: 'card-title',
        domProps: { innerHTML: props.title }
      }));
    }
    if (props.subTitle) {
      cardBodyChildren.push(h(props.subTitleTag, {
        staticClass: 'card-subtitle mb-2 text-muted',
        domProps: { innerHTML: props.subTitle }
      }));
    }
    cardBodyChildren.push(slots().default);

    return h(props.bodyTag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'card-body',
      class: [(_ref2 = {
        'card-img-overlay': props.overlay
      }, _defineProperty(_ref2, 'bg-' + props.bodyBgVariant, Boolean(props.bodyBgVariant)), _defineProperty(_ref2, 'border-' + props.bodyBorderVariant, Boolean(props.bodyBorderVariant)), _defineProperty(_ref2, 'text-' + props.bodyTextVariant, Boolean(props.bodyTextVariant)), _ref2), props.bodyClass || {}]
    }), cardBodyChildren);
  }
});

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_copyProps__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__ = __webpack_require__(52);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var props = Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_copyProps__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__["a" /* default */].props, __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__["a" /* default */].bind(null, 'header')), {
  header: {
    type: String,
    default: null
  },
  headerClass: {
    type: [String, Object, Array],
    default: null
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _ref2;

    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots;

    return h(props.headerTag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'card-header',
      class: [props.headerClass, (_ref2 = {}, _defineProperty(_ref2, 'bg-' + props.headerBgVariant, Boolean(props.headerBgVariant)), _defineProperty(_ref2, 'border-' + props.headerBorderVariant, Boolean(props.headerBorderVariant)), _defineProperty(_ref2, 'text-' + props.headerTextVariant, Boolean(props.headerTextVariant)), _ref2)]
    }), slots().default || [h('div', { domProps: { innerHTML: props.header } })]);
  }
});

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_copyProps__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__ = __webpack_require__(52);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var props = Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_copyProps__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__["a" /* default */].props, __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__["a" /* default */].bind(null, 'footer')), {
  footer: {
    type: String,
    default: null
  },
  footerClass: {
    type: [String, Object, Array],
    default: null
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _ref2;

    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots;

    return h(props.footerTag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'card-footer',
      class: [props.footerClass, (_ref2 = {}, _defineProperty(_ref2, 'bg-' + props.footerBgVariant, Boolean(props.footerBgVariant)), _defineProperty(_ref2, 'border-' + props.footerBorderVariant, Boolean(props.footerBorderVariant)), _defineProperty(_ref2, 'text-' + props.footerTextVariant, Boolean(props.footerTextVariant)), _ref2)]
    }), slots().default || [h('div', { domProps: { innerHTML: props.footer } })]);
  }
});

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(4);


var props = {
  src: {
    type: String,
    default: null,
    required: true
  },
  alt: {
    type: String,
    default: null
  },
  top: {
    type: Boolean,
    default: false
  },
  bottom: {
    type: Boolean,
    default: false
  },
  fluid: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots;

    var staticClass = 'card-img';
    if (props.top) {
      staticClass += '-top';
    } else if (props.bottom) {
      staticClass += '-bottom';
    }

    return h('img', Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: staticClass,
      class: { 'img-fluid': props.fluid },
      attrs: { src: props.src, alt: props.alt }
    }));
  }
});

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(107);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("92b9b9d6", content, true, {});

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".wrapper[data-v-43cc4def]{position:relative;overflow:hidden}.wrapper.page[data-v-43cc4def]{margin-left:-15px;margin-right:-15px}.background[data-v-43cc4def]{background-repeat:no-repeat;position:absolute;top:0;bottom:0;left:0;right:0;z-index:1}.background.cover[data-v-43cc4def]{background-size:cover}.background.contain[data-v-43cc4def]{background-size:contain}.background.left[data-v-43cc4def]{background-position-x:left}.background.center[data-v-43cc4def]{background-position-x:center}.background.right[data-v-43cc4def]{background-position-x:right}.background.top[data-v-43cc4def]{background-position-y:top}.background.middle[data-v-43cc4def]{background-position-y:center}.background.bottom[data-v-43cc4def]{background-position-y:bottom}.overlay[data-v-43cc4def]{position:absolute;top:0;bottom:0;left:0;right:0;z-index:2}.content[data-v-43cc4def]{position:relative;z-index:3}", ""]);

// exports


/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['wrapper', { page: _vm.page }]},[_c('div',{class:['background', (_vm.size || '').toLowerCase(), (_vm.position || '').toLowerCase() ],style:([{ backgroundColor: _vm.backgroundColor, backgroundImage: _vm.backgroundImage }, _vm.backgroundStyleObj])}),_vm._v(" "),_c('div',{staticClass:"overlay",style:([{ backgroundImage: _vm.overlayBackgroundImage}, _vm.overlayStyleObj])}),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []


/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[(_vm.title || _vm.badge || _vm.subtitle)?_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{class:{ 'has-badge': _vm.badge }},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.badge)?_c('span',{staticClass:"badge badge-secondary text-uppercase space-left"},[_vm._v(_vm._s(_vm.badge))]):_vm._e(),_vm._v(" "),(_vm.subtitle)?_c('em',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._t("default",[_c('background',_vm._b({},'background',_vm.background,false),[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),(_vm.downloadLink || _vm.contentLink || _vm.externalLink)?_c('p'):_vm._e(),_vm._v(" "),(_vm.downloadLink || _vm.contentLink || _vm.externalLink)?_c('p',[_c('a',{staticClass:"card-link",attrs:{"href":_vm.downloadLink || _vm.contentLink || _vm.externalLink,"target":_vm.downloadLink || !_vm.contentLink ? '_blank' : ''}},[_vm._v(_vm._s(_vm.externalLinkText || "More information »"))])]):_vm._e()])]),_vm._v(" "),(_vm.footer)?_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('span',[_vm._v(_vm._s(_vm.footer))])]):_vm._e()],2)}
var staticRenderFns = []


/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var ResponsiveImage = /** @class */ (function (_super) {
    __extends(ResponsiveImage, _super);
    function ResponsiveImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ResponsiveImage.prototype, "srcset", {
        get: function () {
            var crops = this.$props.crops;
            if (crops.length === 0)
                return undefined;
            var src = getMediaUrl(this.$props.src);
            var srcset = "";
            crops
                .forEach(function (p) { return srcset += ", " + src + "?width=" + p.width + " " + p.width + "w"; });
            return srcset.substr(", ".length);
        },
        enumerable: true,
        configurable: true
    });
    ResponsiveImage.prototype.convertToPercent = function (value) {
        value = Math.round(value * 100);
        return value + "%";
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String, required: true })
    ], ResponsiveImage.prototype, "src", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Object, default: function () { return ({ left: 0.5, top: 0.5 }); } })
    ], ResponsiveImage.prototype, "focalPoint", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Array, default: function () { return []; } })
    ], ResponsiveImage.prototype, "crops", void 0);
    ResponsiveImage = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "ResponsiveImage"
        })
    ], ResponsiveImage);
    return ResponsiveImage;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (ResponsiveImage);
;
function getMediaUrl(url) {
    var index = url.search(/\/media\//i);
    if (index === -1)
        return url;
    return url.substr(index);
}


/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var Testimonial = /** @class */ (function (_super) {
    __extends(Testimonial, _super);
    function Testimonial() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String, required: true })
    ], Testimonial.prototype, "text", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String, required: true })
    ], Testimonial.prototype, "author", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Testimonial.prototype, "authorTitle", void 0);
    Testimonial = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "Testimonial"
        })
    ], Testimonial);
    return Testimonial;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Testimonial);
;


/***/ }),

/***/ 1296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_App_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WinterCourseYear_vue__ = __webpack_require__(1297);



var vm = window.$vm = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
    name: "App",
    el: "app",
    components: {
        App: __WEBPACK_IMPORTED_MODULE_1__App_App_vue__["a" /* default */],
        WinterCourseYear: __WEBPACK_IMPORTED_MODULE_2__WinterCourseYear_vue__["a" /* default */]
    }
});


/***/ }),

/***/ 1297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WinterCourseYear_vue__ = __webpack_require__(910);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b106641c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WinterCourseYear_vue__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1298)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b106641c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WinterCourseYear_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b106641c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WinterCourseYear_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b106641c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WinterCourseYear_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1298:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1299);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("60884ab7", content, true, {});

/***/ }),

/***/ 1299:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".information .card-columns[data-v-b106641c]{-webkit-column-count:1;-moz-column-count:1;column-count:1}@media (min-width:768px){.information .card-columns[data-v-b106641c]{-webkit-column-count:2;-moz-column-count:2;column-count:2}}@media (min-width:992px){.information .card-columns[data-v-b106641c]{-webkit-column-count:3;-moz-column-count:3;column-count:3}}.pricing>li[data-v-b106641c],.rates>li[data-v-b106641c]{margin-bottom:1rem}.pricing>li[data-v-b106641c]:last-child,.rates>li[data-v-b106641c]:last-child{margin-bottom:0}.results .card-columns[data-v-b106641c]{-webkit-column-count:1;-moz-column-count:1;column-count:1}@media (min-width:768px){.results .card-columns[data-v-b106641c]{-webkit-column-count:2;-moz-column-count:2;column-count:2}}@media (min-width:992px){.results .card-columns[data-v-b106641c]{-webkit-column-count:3;-moz-column-count:3;column-count:3}}.results .card[data-v-b106641c]{background-color:unset;border:0}.results .card .card-body[data-v-b106641c]{padding:0}", ""]);

// exports


/***/ }),

/***/ 1300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cover',{attrs:{"title":_vm.general.title,"description":_vm.general.shortDescription,"long-description":_vm.general.longDescription,"hashtags":_vm.socialMedia && _vm.socialMedia.tags,"images":_vm.banner && _vm.banner.images}}),_vm._v(" "),_c('alert-list',{attrs:{"default":""}}),_vm._v(" "),_c('div',{staticClass:"information"},[_c('b-card-group',{attrs:{"columns":""}},[_c('card',{attrs:{"title":"Registration"}},[_c('register',{attrs:{"register-url":_vm.registerUrl,"registration-url":_vm.registrationUrl,"registered":_vm.registered,"start":_vm.registrationStart}})],1),_vm._v(" "),_vm._l((_vm.information),function(info,index){return _c('card',_vm._b({key:index},'card',info.content,false))}),_vm._v(" "),_c('card',{attrs:{"title":"Pricing"}},[_c('ul',{staticClass:"list-unstyled mb-0 pricing"},[(_vm.tuition && _vm.tuition.rates && _vm.tuition.rates.length !== 0)?_c('li',[_c('h5',[_vm._v("Tuition")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled mb-0 rates"},_vm._l((_vm.tuition.rates),function(rate,index){return _c('li',{key:index},[_c('rate',_vm._b({},'rate',rate,false))],1)}))]):_vm._e(),_vm._v(" "),(_vm.universityCredit && _vm.universityCredit.rates && _vm.universityCredit.rates.length !== 0)?_c('li',[_c('h5',[_vm._v("University Credit")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled mb-0 rates"},_vm._l((_vm.universityCredit.rates),function(rate,index){return _c('li',{key:index},[_c('rate',_vm._b({},'rate',rate,false))],1)}))]):_vm._e(),_vm._v(" "),((!_vm.tuition || !_vm.tuition.rates || _vm.tuition.rates.length === 0) && (!_vm.universityCredit || !_vm.universityCredit.rates || _vm.universityCredit.rates.length === 0))?_c('li',[_vm._v("\n                        TBD\n                    ")]):_vm._e()])]),_vm._v(" "),(_vm.resources.length !== 0)?_c('card',{attrs:{"title":"Resources"}},[_c('p',[_vm._v("See the following for additional resources:")]),_vm._v(" "),_vm._l((_vm.resources),function(resource,index){return _c('ul',{key:index,staticClass:"list-unstyled mb-0"},[_c('li',[_c('a',{attrs:{"href":resource.url,"target":"_blank"}},[_vm._v(_vm._s(resource.text))])])])})],2):_vm._e(),_vm._v(" "),_c('card',{attrs:{"title":"Questions?"}},[_c('coordinators',{attrs:{"general-email":_vm.generalEmail,"email-subject":_vm.general.title,"general-phone-number":_vm.generalPhoneNumber}})],1)],2)],1),_vm._v(" "),_c('div',{staticClass:"container courses"},[_c('breadcrumb-anchor',{attrs:{"id":"search","title":"Search for a course"}},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"map"},[(_vm.courses.length !== 0)?_c('div',{staticClass:"dataset"},[_c('div',{staticClass:"results"},[_c('b-card-group',{attrs:{"columns":""}},_vm._l((_vm.courses),function(result,index){return _c('card',{key:index},[_c('div',[_c('a',{attrs:{"href":result.url}},[_c('span',{staticClass:"h4"},[_vm._v(_vm._s(index + 1)+". "+_vm._s(result.title))])]),_vm._v(" "),_c('div',{staticClass:"text-muted"},[(result.line1)?_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(result.line1))]):_vm._e(),_vm._v(" "),(result.line2)?_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(result.line2))]):_vm._e(),_vm._v(" "),(result.city && result.state && result.zip)?_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(result.city)+", "+_vm._s(result.state)+" "+_vm._s(result.zip))]):_vm._e()])])])}))],1)]):_vm._e()])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_es_components_alert_alert__ = __webpack_require__(45);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var AlertList = /** @class */ (function (_super) {
    __extends(AlertList, _super);
    function AlertList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localValue = _this.default ? window.messages : (_this.value || []);
        return _this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Array, default: function () { return []; } })
    ], AlertList.prototype, "value", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Boolean, default: false })
    ], AlertList.prototype, "default", void 0);
    AlertList = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "AlertList",
            components: {
                "alert": __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_es_components_alert_alert__["a" /* default */]
            }
        })
    ], AlertList);
    return AlertList;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (AlertList);
;


/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_es_components_layout_row__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_es_components_layout_col__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_breadcrumb_breadcrumb__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_components_breadcrumb_breadcrumb_item__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components_card_card_group__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_es_components_card_card__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_PhoneNumber_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_Distance_vue__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Helpers_BingMaps_ts__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue_es_components_form_select_form_select__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_es_components_form_input_form_input__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue_es_components_input_group_input_group__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_es_components_input_group_input_group_addon__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_es_directives_tooltip_tooltip__ = __webpack_require__(113);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};















var credentials = window.config.bingMap.credentials;
var BingMap = /** @class */ (function (_super) {
    __extends(BingMap, _super);
    function BingMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isGps = false;
        _this.canUseGps = true;
        _this.locationSearchText = "";
        _this.locationSearchError = "";
        _this.locationSearchResults = [];
        _this.localRadius = _this.radius;
        _this.rendered = false;
        _this.activeNearby = null;
        _this.nearbyResults = [];
        _this.nearbyResultsTotal = 0;
        _this.activeNearbyResult = null;
        _this.dataset = [];
        _this.datasetResults = [];
        _this.activeDatasetResult = null;
        return _this;
    }
    BingMap.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, address, search, location_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_9__Helpers_BingMaps_ts__["a" /* create */](this.credentials, this.$refs.root)];
                    case 1:
                        _a.map = _b.sent();
                        if (!this.useGps) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.onGpsClick()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        if (!this.location) return [3 /*break*/, 6];
                        address = this.location;
                        return [4 /*yield*/, this.map.getSearch()];
                    case 4:
                        search = _b.sent();
                        return [4 /*yield*/, search.geocode(address.line1, address.city, address.state, address.zip)];
                    case 5:
                        location_1 = (_b.sent()).results
                            .map(function (p) { return p.location; })[0];
                        this.setNonGpsLocation(location_1);
                        _b.label = 6;
                    case 6:
                        if (!(this.addresses.length !== 0)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.initializeDataset(this.addresses)];
                    case 7:
                        _b.sent();
                        _b.label = 8;
                    case 8:
                        this.rendered = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    BingMap.prototype.onGpsClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var location;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.locationSearchText = "";
                        this.setLocationSearchError();
                        this.locationSearchResults = [];
                        return [4 /*yield*/, this.map.addCurrentLocationPushpin()];
                    case 1:
                        location = _a.sent();
                        this.map.setViewToAll();
                        this.canUseGps = !!location;
                        this.isGps = !!location;
                        return [4 /*yield*/, this.calculateDatasetDistance()];
                    case 2:
                        _a.sent();
                        this.sortAndFilterDataset();
                        return [2 /*return*/];
                }
            });
        });
    };
    BingMap.prototype.setNonGpsLocation = function (location) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.map.addCurrentLocationPushpin(location)];
                    case 1:
                        _a.sent();
                        this.map.setViewToAll();
                        this.isGps = false;
                        return [4 /*yield*/, this.calculateDatasetDistance()];
                    case 2:
                        _a.sent();
                        this.sortAndFilterDataset();
                        return [2 /*return*/];
                }
            });
        });
    };
    BingMap.prototype.onLocationSearchClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var search, results, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocationSearchError();
                        this.locationSearchResults = [];
                        if (!this.locationSearchText)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.map.getSearch()];
                    case 1:
                        search = _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, search.geocode(this.locationSearchText)];
                    case 3:
                        results = (_b.sent()).results;
                        if (results.length === 0) {
                            this.setLocationSearchError("Could not find location");
                        }
                        else if (results.length === 1) {
                            this.setNonGpsLocation(results[0].location);
                        }
                        else {
                            this.locationSearchResults = results;
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _b.sent();
                        this.setLocationSearchError("Could not find location");
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BingMap.prototype.onLocationSearchResultClick = function (result) {
        this.locationSearchText = result.name;
        this.setLocationSearchError();
        this.locationSearchResults = [];
        this.setNonGpsLocation(result.location);
    };
    BingMap.prototype.setLocationSearchError = function (error) {
        if (error === void 0) { error = ""; }
        this.locationSearchError = error;
        if (error) {
            this.$refs.locationSearch.focus();
        }
    };
    BingMap.prototype.searchNearby = function (nearby) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var term, search, results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resetNearby(false);
                        this.activeNearby = nearby;
                        term = typeof nearby === "object"
                            ? nearby.term
                            : nearby;
                        return [4 /*yield*/, this.map.getSpatialData()];
                    case 1:
                        search = _a.sent();
                        return [4 /*yield*/, search.nearby(term)];
                    case 2:
                        results = _a.sent();
                        this.nearbyResults = results.data
                            .map(function (p) {
                            var result = convertBingSearchResult(p, _this.map.module);
                            result.infoboxOptions = {
                                description: result.address.title
                            };
                            result.pin = _this.map.addPushpin(new _this.map.module.Location(p.metadata.Latitude, p.metadata.Longitude), undefined, result.infoboxOptions);
                            _this.map.module.Events.addHandler(result.pin, "mouseover", function () {
                                _this.activeNearbyResult = result;
                            });
                            return result;
                        });
                        this.nearbyResultsTotal = results.total;
                        this.map.setViewToAll();
                        return [2 /*return*/];
                }
            });
        });
    };
    BingMap.prototype.resetNearby = function (resetView) {
        if (resetView === void 0) { resetView = true; }
        this.activeNearby = null;
        this.nearbyResults = [];
        this.nearbyResultsTotal = 0;
        this.activeNearbyResult = null;
        this.map.clearPushpins();
        this.map.hideInfobox();
        if (resetView) {
            this.map.setViewToAll();
        }
    };
    BingMap.prototype.clickNearby = function (result) {
        this.overNearby(result);
    };
    BingMap.prototype.overNearby = function (result) {
        this.activeNearbyResult = result;
        result.location && result.infoboxOptions && this.map.showInfobox(result.location, result.infoboxOptions);
    };
    BingMap.prototype.outNearby = function (result) {
        this.activeNearbyResult = null;
        this.map.hideInfobox();
    };
    BingMap.prototype.initializeDataset = function (addresses) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var search, locationSearches;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.map.getSearch()];
                    case 1:
                        search = _a.sent();
                        this.dataset = addresses.map(function (p) {
                            return {
                                address: p,
                                distance: 0,
                                infoboxOptions: {
                                    description: p.title
                                }
                            };
                        });
                        locationSearches = this.dataset.map(function (p) { return search.geocode(p.address.line1, p.address.city, p.address.state, p.address.zip); });
                        Promise.all(locationSearches).then(function (locations) {
                            for (var i = 0; i < locations.length; i++) {
                                _this.dataset[i].location = locations[i].results[0].location;
                                _this.dataset[i].distance = i;
                            }
                        })
                            .then(function (p) { return _this.calculateDatasetDistance(); })
                            .then(function (p) { return _this.sortAndFilterDataset(); });
                        this.sortAndFilterDataset();
                        return [2 /*return*/];
                }
            });
        });
    };
    BingMap.prototype.calculateDatasetDistance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var spatialMath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.map.getSpatialMath()];
                    case 1:
                        spatialMath = _a.sent();
                        this.dataset
                            .filter(function (p) { return !p.location || !_this.map.currentLocation; })
                            .forEach(function (p) { return p.distance = 0; });
                        this.dataset
                            .filter(function (p) { return !!p.location && !!_this.map.currentLocation; })
                            .forEach(function (p) { return p.distance = spatialMath.getDistanceTo(_this.map.currentLocation, p.location, Microsoft.Maps.SpatialMath.DistanceUnits.Miles); });
                        return [2 /*return*/];
                }
            });
        });
    };
    BingMap.prototype.sortAndFilterDataset = function (radius) {
        var _this = this;
        radius = radius || this.localRadius;
        this.datasetResults = this.dataset
            .filter(function (p) { return radius === -1 || p.distance <= radius; })
            .sort(function (l, r) { return l.distance - r.distance; });
        this.map.clearPushpins();
        this.datasetResults
            .filter(function (p) { return !!p.location; })
            .forEach(function (p) { return p.pin = _this.map.addPushpin(p.location, undefined, p.infoboxOptions); });
        this.map.setViewToAll();
    };
    BingMap.prototype.overDatasetResult = function (result) {
        this.activeDatasetResult = result;
        result.location && result.infoboxOptions && this.map.showInfobox(result.location, result.infoboxOptions);
    };
    BingMap.prototype.outDatasetResult = function (result) {
        this.activeDatasetResult = null;
        this.map.hideInfobox();
    };
    BingMap.prototype.reset = function () {
        this.resetNearby();
        this.map.resetView();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String, default: credentials })
    ], BingMap.prototype, "credentials", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Boolean, default: false })
    ], BingMap.prototype, "useGps", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Boolean, default: false })
    ], BingMap.prototype, "useLocationSearch", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Boolean, default: false })
    ], BingMap.prototype, "useRadius", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Array, default: function () { return [
                { value: 25, text: "25 miles" },
                { value: 100, text: "100 miles" },
                { value: 250, text: "250 miles" },
                { value: -1, text: "All" },
            ]; } })
    ], BingMap.prototype, "radii", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Number, default: -1 })
    ], BingMap.prototype, "radius", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Object })
    ], BingMap.prototype, "location", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Array, default: function () { return []; } })
    ], BingMap.prototype, "nearby", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Array, default: function () { return []; } })
    ], BingMap.prototype, "addresses", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Boolean, default: false })
    ], BingMap.prototype, "showAddressesList", void 0);
    BingMap = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "BingMap",
            directives: {
                "b-tooltip": __WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_es_directives_tooltip_tooltip__["a" /* default */]
            },
            components: {
                PhoneNumber: __WEBPACK_IMPORTED_MODULE_7__Components_PhoneNumber_vue__["a" /* default */],
                Distance: __WEBPACK_IMPORTED_MODULE_8__Components_Distance_vue__["a" /* default */],
                "b-row": __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_es_components_layout_row__["a" /* default */],
                "b-col": __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_es_components_layout_col__["a" /* default */],
                "b-breadcrumb": __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_breadcrumb_breadcrumb__["a" /* default */],
                "b-breadcrumb-item": __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_components_breadcrumb_breadcrumb_item__["a" /* default */],
                "b-card-group": __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_es_components_card_card_group__["a" /* default */],
                "b-card": __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_es_components_card_card__["a" /* default */],
                "form-input": __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_es_components_form_input_form_input__["a" /* default */],
                "input-group": __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue_es_components_input_group_input_group__["a" /* default */],
                "input-group-addon": __WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_es_components_input_group_input_group_addon__["a" /* default */],
                "form-select": __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue_es_components_form_select_form_select__["a" /* default */]
            }
        })
    ], BingMap);
    return BingMap;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (BingMap);
;
function convertBingSearchResult(result, module) {
    return {
        address: {
            title: result.metadata.DisplayName,
            line1: result.metadata.AddressLine,
            city: result.metadata.AdminDistrict2,
            state: result.metadata.AdminDistrict,
            zip: result.metadata.PostalCode,
            phoneNumber: result.metadata.Phone
        },
        distance: result.metadata.__Distance,
        location: new module.Location(result.metadata.Latitude, result.metadata.Longitude)
    };
}


/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhoneNumber_vue__ = __webpack_require__(166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f1da75f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhoneNumber_vue__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhoneNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f1da75f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhoneNumber_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f1da75f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhoneNumber_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var PhoneNumber = /** @class */ (function (_super) {
    __extends(PhoneNumber, _super);
    function PhoneNumber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PhoneNumber.prototype, "phoneNumber", {
        get: function () {
            var trimmed = this.value.replace(/[-\/\(\)]/g, '');
            if (trimmed.length !== 10)
                return this.value;
            return "(" + trimmed.substr(0, 3) + ") " + trimmed.substr(3, 3) + "-" + trimmed.substr(6, 4);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String, default: "fa-phone" })
    ], PhoneNumber.prototype, "icon", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String, required: true })
    ], PhoneNumber.prototype, "value", void 0);
    PhoneNumber = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "PhoneNumber"
        })
    ], PhoneNumber);
    return PhoneNumber;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (PhoneNumber);
;


/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var PhoneNumber = /** @class */ (function (_super) {
    __extends(PhoneNumber, _super);
    function PhoneNumber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PhoneNumber.prototype, "distance", {
        get: function () {
            var offset = Math.max(10 * this.precision, 1);
            return Math.round(this.value * offset) / offset;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], PhoneNumber.prototype, "icon", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Number, required: true })
    ], PhoneNumber.prototype, "value", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Number, default: 0 })
    ], PhoneNumber.prototype, "precision", void 0);
    PhoneNumber = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "Distance"
        })
    ], PhoneNumber);
    return PhoneNumber;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (PhoneNumber);
;


/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContactInformation_vue__ = __webpack_require__(268);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var Coordinators = /** @class */ (function (_super) {
    __extends(Coordinators, _super);
    function Coordinators() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Array, default: function () { return []; } })
    ], Coordinators.prototype, "coordinators", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Coordinators.prototype, "generalEmail", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Coordinators.prototype, "emailSubject", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Coordinators.prototype, "generalPhoneNumber", void 0);
    Coordinators = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "Coordinators",
            components: {
                ContactInformation: __WEBPACK_IMPORTED_MODULE_1__ContactInformation_vue__["a" /* default */]
            }
        })
    ], Coordinators);
    return Coordinators;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Coordinators);
;


/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProfilePicture_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PhoneNumber_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EmailAddress_vue__ = __webpack_require__(269);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var ContactInformation = /** @class */ (function (_super) {
    __extends(ContactInformation, _super);
    function ContactInformation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Object })
    ], ContactInformation.prototype, "profile", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], ContactInformation.prototype, "email", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], ContactInformation.prototype, "emailSubject", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], ContactInformation.prototype, "phoneNumber", void 0);
    ContactInformation = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "ContactInformation",
            components: {
                ProfilePicture: __WEBPACK_IMPORTED_MODULE_1__ProfilePicture_vue__["a" /* default */],
                PhoneNumber: __WEBPACK_IMPORTED_MODULE_2__PhoneNumber_vue__["a" /* default */],
                EmailAddress: __WEBPACK_IMPORTED_MODULE_3__EmailAddress_vue__["a" /* default */]
            }
        })
    ], ContactInformation);
    return ContactInformation;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (ContactInformation);
;


/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Key Codes (events)
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  SPACE: 32,
  ENTER: 13,
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  PAGEUP: 33,
  PAGEDOWN: 34,
  HOME: 36,
  END: 35
});

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var EmailAddress = /** @class */ (function (_super) {
    __extends(EmailAddress, _super);
    function EmailAddress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EmailAddress.prototype, "href", {
        get: function () {
            var href = "mailto:" + this.value;
            if (this.subject) {
                href += "?subject=" + this.subject;
            }
            return href;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String, default: "fa-envelope" })
    ], EmailAddress.prototype, "icon", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String, required: true })
    ], EmailAddress.prototype, "value", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], EmailAddress.prototype, "subject", void 0);
    EmailAddress = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "EmailAddress"
        })
    ], EmailAddress);
    return EmailAddress;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (EmailAddress);
;


/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_es_components_layout_row__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_layout_col__ = __webpack_require__(14);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var Rate = /** @class */ (function (_super) {
    __extends(Rate, _super);
    function Rate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.now = __WEBPACK_IMPORTED_MODULE_1_moment__().startOf('day');
        return _this;
    }
    Object.defineProperty(Rate.prototype, "localStart", {
        get: function () {
            return typeof this.start === "string"
                ? __WEBPACK_IMPORTED_MODULE_1_moment__(this.start)
                : this.start;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rate.prototype, "localEnd", {
        get: function () {
            return typeof this.end === "string"
                ? __WEBPACK_IMPORTED_MODULE_1_moment__(this.end)
                : this.end;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rate.prototype, "unavailable", {
        get: function () {
            return (this.type === 'date' && this.localEnd && this.localEnd.isBefore(this.now));
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String, default: "dddd, LL" })
    ], Rate.prototype, "dateFormat", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String, required: true })
    ], Rate.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String, required: true })
    ], Rate.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Rate.prototype, "note", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Boolean, required: true })
    ], Rate.prototype, "isFree", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Number, default: 0 })
    ], Rate.prototype, "price", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Rate.prototype, "priceNote", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Number })
    ], Rate.prototype, "minAge", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Number })
    ], Rate.prototype, "maxAge", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: [Object, String] })
    ], Rate.prototype, "start", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: [Object, String] })
    ], Rate.prototype, "end", void 0);
    Rate = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "Rate",
            components: {
                "b-row": __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_es_components_layout_row__["a" /* default */],
                "b-col": __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_layout_col__["a" /* default */]
            }
        })
    ], Rate);
    return Rate;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Rate);
;


/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = observeDOM;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(16);



/**
 * Observe a DOM element changes, falls back to eventListener mode
 * @param {Element} el The DOM element to observe
 * @param {Function} callback callback to be called on change
 * @param {object} [opts={childList: true, subtree: true}] observe options
 * @see http://stackoverflow.com/questions/3219758
 */
function observeDOM(el, callback, opts) {
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
  var eventListenerSupported = window.addEventListener;

  // Handle case where we might be passed a vue instance
  el = el ? el.$el || el : null;
  /* istanbul ignore next: dificult to test in JSDOM */
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["k" /* isElement */])(el)) {
    // We can't observe somthing that isn't an element
    return null;
  }

  var obs = null;

  /* istanbul ignore next: dificult to test in JSDOM */
  if (MutationObserver) {
    // Define a new observer
    obs = new MutationObserver(function (mutations) {
      var changed = false;
      // A Mutation can contain several change records, so we loop through them to see what has changed.
      // We break out of the loop early if any "significant" change has been detected
      for (var i = 0; i < mutations.length && !changed; i++) {
        // The muttion record
        var mutation = mutations[i];
        // Mutation Type
        var type = mutation.type;
        // DOM Node (could be any DOM Node type - HTMLElement, Text, comment, etc)
        var target = mutation.target;
        if (type === 'characterData' && target.nodeType === Node.TEXT_NODE) {
          // We ignore nodes that are not TEXt (i.e. comments, etc) as they don't change layout
          changed = true;
        } else if (type === 'attributes') {
          changed = true;
        } else if (type === 'childList' && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
          // This includes HTMLElement and Text Nodes being added/removed/re-arranged
          changed = true;
        }
      }
      if (changed) {
        // We only call the callback if a change that could affect layout/size truely happened.
        callback();
      }
    });

    // Have the observer observe foo for changes in children, etc
    obs.observe(el, Object(__WEBPACK_IMPORTED_MODULE_0__object__["a" /* assign */])({ childList: true, subtree: true }, opts));
  } else if (eventListenerSupported) {
    // Legacy interface. most likely not used in modern browsers
    el.addEventListener('DOMNodeInserted', callback, false);
    el.addEventListener('DOMNodeRemoved', callback, false);
  }

  // We return a reference to the observer so that obs.disconnect() can be called if necessary
  // To reduce overhead when the root element is hiiden
  return obs;
}

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pluckProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(21);




/**
 * Given an array of properties or an object of property keys,
 * plucks all the values off the target object.
 * @param {{}|string[]} keysToPluck
 * @param {{}} objToPluck
 * @param {Function} transformFn
 * @return {{}}
 */
function pluckProps(keysToPluck, objToPluck) {
  var transformFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */];

  return (Object(__WEBPACK_IMPORTED_MODULE_1__array__["d" /* isArray */])(keysToPluck) ? keysToPluck.slice() : Object(__WEBPACK_IMPORTED_MODULE_0__object__["e" /* keys */])(keysToPluck)).reduce(function (memo, prop) {
    // eslint-disable-next-line no-sequences
    return memo[transformFn(prop)] = objToPluck[prop], memo;
  }, {});
}

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coordinators_vue__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27aadde0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coordinators_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(266)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27aadde0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coordinators_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27aadde0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coordinators_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27aadde0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coordinators_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
function identity(x) {
  return x;
}

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(4);


var props = {
  tag: {
    type: String,
    default: 'div'
  },
  deck: {
    type: Boolean,
    default: false
  },
  columns: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var staticClass = 'card-group';
    if (props.columns) {
      staticClass = 'card-columns';
    }
    if (props.deck) {
      staticClass = 'card-deck';
    }

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, { staticClass: staticClass }), children);
  }
});

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResponsiveImage_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fe4156c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResponsiveImage_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(35)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fe4156c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResponsiveImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fe4156c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResponsiveImage_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fe4156c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResponsiveImage_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = propsFactory;
/* unused harmony export props */
/* unused harmony export pickLinkProps */
/* unused harmony export omitLinkProps */
/* unused harmony export computed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_object__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_functional_data_merge__ = __webpack_require__(4);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





/**
 * The Link component is used in many other BV components.
 * As such, sharing its props makes supporting all its features easier.
 * However, some components need to modify the defaults for their own purpose.
 * Prefer sharing a fresh copy of the props to ensure mutations
 * do not affect other component references to the props.
 *
 * https://github.com/vuejs/vue-router/blob/dev/src/components/link.js
 * @return {{}}
 */
function propsFactory() {
  return {
    href: {
      type: String,
      default: null
    },
    rel: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: '_self'
    },
    active: {
      type: Boolean,
      default: false
    },
    activeClass: {
      type: String,
      default: 'active'
    },
    append: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    event: {
      type: [String, Array],
      default: 'click'
    },
    exact: {
      type: Boolean,
      default: false
    },
    exactActiveClass: {
      type: String,
      default: 'active'
    },
    replace: {
      type: Boolean,
      default: false
    },
    routerTag: {
      type: String,
      default: 'a'
    },
    to: {
      type: [String, Object],
      default: null
    }
  };
}

var props = propsFactory();

function pickLinkProps(propsToPick) {
  var freshLinkProps = propsFactory();
  // Normalize everything to array.
  propsToPick = Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["b" /* concat */])(propsToPick);

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["e" /* keys */])(freshLinkProps).reduce(function (memo, prop) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(propsToPick, prop)) {
      memo[prop] = freshLinkProps[prop];
    }

    return memo;
  }, {});
}

function omitLinkProps(propsToOmit) {
  var freshLinkProps = propsFactory();
  // Normalize everything to array.
  propsToOmit = Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["b" /* concat */])(propsToOmit);

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["e" /* keys */])(props).reduce(function (memo, prop) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(propsToOmit, prop)) {
      memo[prop] = freshLinkProps[prop];
    }

    return memo;
  }, {});
}

var computed = {
  linkProps: function linkProps() {
    var linkProps = {};
    var propKeys = Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["e" /* keys */])(props);

    for (var i = 0; i < propKeys.length; i++) {
      var prop = propKeys[i];
      // Computed Vue getters are bound to the instance.
      linkProps[prop] = this[prop];
    }

    return linkProps;
  }
};

function computeTag(props, parent) {
  return Boolean(parent.$router) && props.to && !props.disabled ? 'router-link' : 'a';
}

function computeHref(_ref, tag) {
  var disabled = _ref.disabled,
      href = _ref.href,
      to = _ref.to;

  // We've already checked the parent.$router in computeTag,
  // so router-link means live router.
  // When deferring to Vue Router's router-link,
  // don't use the href attr at all.
  // Must return undefined for router-link to populate href.
  if (tag === 'router-link') return void 0;
  // If href explicitly provided
  if (href) return href;
  // Reconstruct href when `to` used, but no router
  if (to) {
    // Fallback to `to` prop (if `to` is a string)
    if (typeof to === 'string') return to;
    // Fallback to `to.path` prop (if `to` is an object)
    if ((typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' && typeof to.path === 'string') return to.path;
  }
  // If nothing is provided use '#'
  return '#';
}

function computeRel(_ref2) {
  var target = _ref2.target,
      rel = _ref2.rel;

  if (target === '_blank' && rel === null) {
    return 'noopener';
  }
  return rel || null;
}

function clickHandlerFactory(_ref3) {
  var disabled = _ref3.disabled,
      tag = _ref3.tag,
      href = _ref3.href,
      suppliedHandler = _ref3.suppliedHandler,
      parent = _ref3.parent;

  var isRouterLink = tag === 'router-link';

  return function onClick(e) {
    if (disabled && e instanceof Event) {
      // Stop event from bubbling up.
      e.stopPropagation();
      // Kill the event loop attached to this specific EventTarget.
      e.stopImmediatePropagation();
    } else {
      parent.$root.$emit('clicked::link', e);

      if (isRouterLink && e.target.__vue__) {
        e.target.__vue__.$emit('click', e);
      }
      if (typeof suppliedHandler === 'function') {
        suppliedHandler.apply(undefined, arguments);
      }
    }

    if (!isRouterLink && href === '#' || disabled) {
      // Stop scroll-to-top behavior or navigation.
      e.preventDefault();
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: propsFactory(),
  render: function render(h, _ref4) {
    var props = _ref4.props,
        data = _ref4.data,
        parent = _ref4.parent,
        children = _ref4.children;

    var tag = computeTag(props, parent);
    var rel = computeRel(props);
    var href = computeHref(props, tag);
    var eventType = tag === 'router-link' ? 'nativeOn' : 'on';
    var suppliedHandler = (data[eventType] || {}).click;
    var handlers = { click: clickHandlerFactory({ tag: tag, href: href, disabled: props.disabled, suppliedHandler: suppliedHandler, parent: parent }) };

    var componentData = Object(__WEBPACK_IMPORTED_MODULE_2_vue_functional_data_merge__["a" /* mergeData */])(data, {
      class: [props.active ? props.exact ? props.exactActiveClass : props.activeClass : null, { disabled: props.disabled }],
      attrs: {
        rel: rel,
        href: href,
        target: props.target,
        tabindex: props.disabled ? '-1' : data.attrs ? data.attrs.tabindex : null,
        'aria-disabled': tag === 'a' && props.disabled ? 'true' : null
      },
      props: Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["a" /* assign */])(props, { tag: props.routerTag })
    });

    // If href prop exists on router-link (even undefined or null) it fails working on SSR
    if (!componentData.attrs.href) {
      delete componentData.attrs.href;
    }

    // We want to overwrite any click handler since our callback
    // will invoke the supplied handler if !props.disabled
    componentData[eventType] = Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["a" /* assign */])(componentData[eventType] || {}, handlers);

    return h(tag, componentData, children);
  }
});

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_observe_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_id__ = __webpack_require__(8);





// Slide directional classes
var DIRECTION = {
  next: {
    dirClass: 'carousel-item-left',
    overlayClass: 'carousel-item-next'
  },
  prev: {
    dirClass: 'carousel-item-right',
    overlayClass: 'carousel-item-prev'
  }

  // Fallback Transition duration (with a little buffer) in ms
};var TRANS_DURATION = 600 + 50;

// Transition Event names
var TransitionEndEvents = {
  WebkitTransition: 'webkitTransitionEnd',
  MozTransition: 'transitionend',
  OTransition: 'otransitionend oTransitionEnd',
  transition: 'transitionend'

  // Return the browser specific transitionend event name
};function getTransisionEndEvent(el) {
  for (var name in TransitionEndEvents) {
    if (el.style[name] !== undefined) {
      return TransitionEndEvents[name];
    }
  }
  // fallback
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_id__["a" /* default */]],
  render: function render(h) {
    var t = this;

    // Wrapper for slides
    var inner = h('div', {
      ref: 'inner',
      class: ['carousel-inner'],
      attrs: {
        id: t.safeId('__BV_inner_'),
        role: 'list'
      }
    }, [t.$slots.default]);

    // Prev and Next Controls
    var controls = h(false);
    if (t.controls) {
      controls = [h('a', {
        class: ['carousel-control-prev'],
        attrs: { href: '#', role: 'button', 'aria-controls': t.safeId('__BV_inner_') },
        on: {
          click: function click(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            t.prev();
          },
          keydown: function keydown(evt) {
            var keyCode = evt.keyCode;
            if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].SPACE || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].ENTER) {
              evt.preventDefault();
              evt.stopPropagation();
              t.prev();
            }
          }
        }
      }, [h('span', { class: ['carousel-control-prev-icon'], attrs: { 'aria-hidden': 'true' } }), h('span', { class: ['sr-only'] }, [t.labelPrev])]), h('a', {
        class: ['carousel-control-next'],
        attrs: { href: '#', role: 'button', 'aria-controls': t.safeId('__BV_inner_') },
        on: {
          click: function click(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            t.next();
          },
          keydown: function keydown(evt) {
            var keyCode = evt.keyCode;
            if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].SPACE || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].ENTER) {
              evt.preventDefault();
              evt.stopPropagation();
              t.next();
            }
          }
        }
      }, [h('span', { class: ['carousel-control-next-icon'], attrs: { 'aria-hidden': 'true' } }), h('span', { class: ['sr-only'] }, [t.labelNext])])];
    }

    // Indicators
    var indicators = h('ol', {
      class: ['carousel-indicators'],
      directives: [{ name: 'show', rawName: 'v-show', value: t.indicators, expression: 'indicators' }],
      attrs: {
        id: t.safeId('__BV_indicators_'),
        'aria-hidden': t.indicators ? 'false' : 'true',
        'aria-label': t.labelIndicators,
        'aria-owns': t.safeId('__BV_inner_')
      }
    }, t.slides.map(function (slide, n) {
      return h('li', {
        key: 'slide_' + n,
        class: { active: n === t.index },
        attrs: {
          role: 'button',
          id: t.safeId('__BV_indicator_' + (n + 1) + '_'),
          tabindex: t.indicators ? '0' : '-1',
          'aria-current': n === t.index ? 'true' : 'false',
          'aria-label': t.labelGotoSlide + ' ' + (n + 1),
          'aria-describedby': t.slides[n].id || null,
          'aria-controls': t.safeId('__BV_inner_')
        },
        on: {
          click: function click(evt) {
            t.setSlide(n);
          },
          keydown: function keydown(evt) {
            var keyCode = evt.keyCode;
            if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].SPACE || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].ENTER) {
              evt.preventDefault();
              evt.stopPropagation();
              t.setSlide(n);
            }
          }
        }
      });
    }));

    // Return the carousel
    return h('div', {
      class: ['carousel', 'slide'],
      style: { background: t.background },
      attrs: {
        role: 'region',
        id: t.safeId(),
        'aria-busy': t.isSliding ? 'true' : 'false'
      },
      on: {
        mouseenter: t.pause,
        mouseleave: t.restart,
        focusin: t.pause,
        focusout: t.restart,
        keydown: function keydown(evt) {
          var keyCode = evt.keyCode;
          if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].LEFT || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].RIGHT) {
            evt.preventDefault();
            evt.stopPropagation();
            t[keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].LEFT ? 'prev' : 'next']();
          }
        }
      }
    }, [inner, controls, indicators]);
  },
  data: function data() {
    return {
      index: this.value || 0,
      isSliding: false,
      intervalId: null,
      transitionEndEvent: null,
      slides: []
    };
  },

  props: {
    labelPrev: {
      type: String,
      default: 'Previous Slide'
    },
    labelNext: {
      type: String,
      default: 'Next Slide'
    },
    labelGotoSlide: {
      type: String,
      default: 'Goto Slide'
    },
    labelIndicators: {
      type: String,
      default: 'Select a slide to display'
    },
    interval: {
      type: Number,
      default: 5000
    },
    indicators: {
      type: Boolean,
      default: false
    },
    controls: {
      type: Boolean,
      default: false
    },
    imgWidth: {
      // Sniffed by carousel-slide
      type: [Number, String]
    },
    imgHeight: {
      // Sniffed by carousel-slide
      type: [Number, String]
    },
    background: {
      type: String
    },
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isCycling: function isCycling() {
      return Boolean(this.intervalId);
    }
  },
  methods: {
    // Set slide
    setSlide: function setSlide(slide) {
      var _this = this;

      // Don't animate when page is not visible
      if (typeof document !== 'undefined' && document.visibilityState && document.hidden) {
        return;
      }
      var len = this.slides.length;
      // Don't do anything if nothing to slide to
      if (len === 0) {
        return;
      }
      // Don't change slide while transitioning, wait until transition is done
      if (this.isSliding) {
        // Schedule slide after sliding complete
        this.$once('sliding-end', function () {
          return _this.setSlide(slide);
        });
        return;
      }
      // Make sure we have an integer (you never know!)
      slide = Math.floor(slide);
      // Set new slide index. Wrap around if necessary
      this.index = slide >= len ? 0 : slide >= 0 ? slide : len - 1;
    },

    // Previous slide
    prev: function prev() {
      this.setSlide(this.index - 1);
    },

    // Next slide
    next: function next() {
      this.setSlide(this.index + 1);
    },

    // Pause auto rotation
    pause: function pause() {
      if (this.isCycling) {
        clearInterval(this.intervalId);
        this.intervalId = null;
        if (this.slides[this.index]) {
          // Make current slide focusable for screen readers
          this.slides[this.index].tabIndex = 0;
        }
      }
    },

    // Start auto rotate slides
    start: function start() {
      var _this2 = this;

      // Don't start if no intetrval, or if we are already running
      if (!this.interval || this.isCycling) {
        return;
      }
      this.slides.forEach(function (slide) {
        slide.tabIndex = -1;
      });
      this.intervalId = setInterval(function () {
        _this2.next();
      }, Math.max(1000, this.interval));
    },

    // Re-Start auto rotate slides when focus/hover leaves the carousel
    restart: function restart(evt) {
      if (!this.$el.contains(document.activeElement)) {
        this.start();
      }
    },

    // Update slide list
    updateSlides: function updateSlides() {
      this.pause();
      // Get all slides as DOM elements
      this.slides = Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["q" /* selectAll */])('.carousel-item', this.$refs.inner);
      var numSlides = this.slides.length;
      // Keep slide number in range
      var index = Math.max(0, Math.min(Math.floor(this.index), numSlides - 1));
      this.slides.forEach(function (slide, idx) {
        var n = idx + 1;
        if (idx === index) {
          Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["a" /* addClass */])(slide, 'active');
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["o" /* removeClass */])(slide, 'active');
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["r" /* setAttr */])(slide, 'aria-current', idx === index ? 'true' : 'false');
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["r" /* setAttr */])(slide, 'aria-posinset', String(n));
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["r" /* setAttr */])(slide, 'aria-setsize', String(numSlides));
        slide.tabIndex = -1;
      });
      // Set slide as active
      this.setSlide(index);
      this.start();
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setSlide(newVal);
      }
    },
    interval: function interval(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      if (!newVal) {
        // Pausing slide show
        this.pause();
      } else {
        // Restarting or Changing interval
        this.pause();
        this.start();
      }
    },
    index: function index(val, oldVal) {
      var _this3 = this;

      if (val === oldVal || this.isSliding) {
        return;
      }
      // Determine sliding direction
      var direction = val > oldVal ? DIRECTION.next : DIRECTION.prev;
      // Rotates
      if (oldVal === 0 && val === this.slides.length - 1) {
        direction = DIRECTION.prev;
      } else if (oldVal === this.slides.length - 1 && val === 0) {
        direction = DIRECTION.next;
      }
      // Determine current and next slides
      var currentSlide = this.slides[oldVal];
      var nextSlide = this.slides[val];
      // Don't do anything if there aren't any slides to slide to
      if (!currentSlide || !nextSlide) {
        return;
      }
      // Start animating
      this.isSliding = true;
      this.$emit('sliding-start', val);
      // Update v-model
      this.$emit('input', this.index);
      nextSlide.classList.add(direction.overlayClass);
      // Trigger a reflow of next slide
      Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["m" /* reflow */])(nextSlide);
      Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["a" /* addClass */])(currentSlide, direction.dirClass);
      Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["a" /* addClass */])(nextSlide, direction.dirClass);
      // Transition End handler
      var called = false;
      /* istanbul ignore next: dificult to test */
      var onceTransEnd = function onceTransEnd(evt) {
        if (called) {
          return;
        }
        called = true;
        if (_this3.transitionEndEvent) {
          var events = _this3.transitionEndEvent.split(/\s+/);
          events.forEach(function (event) {
            Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["c" /* eventOff */])(currentSlide, event, onceTransEnd);
          });
        }
        _this3._animationTimeout = null;
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["o" /* removeClass */])(nextSlide, direction.dirClass);
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["o" /* removeClass */])(nextSlide, direction.overlayClass);
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["a" /* addClass */])(nextSlide, 'active');
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["o" /* removeClass */])(currentSlide, 'active');
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["o" /* removeClass */])(currentSlide, direction.dirClass);
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["o" /* removeClass */])(currentSlide, direction.overlayClass);
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["r" /* setAttr */])(currentSlide, 'aria-current', 'false');
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["r" /* setAttr */])(nextSlide, 'aria-current', 'true');
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["r" /* setAttr */])(currentSlide, 'aria-hidden', 'true');
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["r" /* setAttr */])(nextSlide, 'aria-hidden', 'false');
        currentSlide.tabIndex = -1;
        nextSlide.tabIndex = -1;
        if (!_this3.isCycling) {
          // Focus the next slide for screen readers if not in play mode
          nextSlide.tabIndex = 0;
          _this3.$nextTick(function () {
            nextSlide.focus();
          });
        }
        _this3.isSliding = false;
        // Notify ourselves that we're done sliding (slid)
        _this3.$nextTick(function () {
          return _this3.$emit('sliding-end', val);
        });
      };
      // Clear transition classes after transition ends
      if (this.transitionEndEvent) {
        var events = this.transitionEndEvent.split(/\s+/);
        events.forEach(function (event) {
          Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["d" /* eventOn */])(currentSlide, event, onceTransEnd);
        });
      }
      // Fallback to setTimeout
      this._animationTimeout = setTimeout(onceTransEnd, TRANS_DURATION);
    }
  },
  created: function created() {
    // Create private non-reactive props
    this._animationTimeout = null;
  },
  mounted: function mounted() {
    // Cache current browser transitionend event name
    this.transitionEndEvent = getTransisionEndEvent(this.$el) || null;
    // Get all slides
    this.updateSlides();
    // Observe child changes so we can update slide list
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_observe_dom__["a" /* default */])(this.$refs.inner, this.updateSlides.bind(this), {
      subtree: false,
      childList: true,
      attributes: true,
      attributeFilter: ['id']
    });
  },

  /* istanbul ignore next: dificult to test */
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
    clearTimeout(this._animationTimeout);
    this.intervalId = null;
    this._animationTimeout = null;
  }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BingMap_vue__ = __webpack_require__(164);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0607622b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BingMap_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(259)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0607622b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BingMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0607622b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BingMap_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0607622b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BingMap_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(260);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("02605b48", content, true, {});

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__image_img__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_warn__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_id__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { bImg: __WEBPACK_IMPORTED_MODULE_0__image_img__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_id__["a" /* default */]],
  render: function render(h) {
    var t = this;
    var $slots = t.$slots;

    var img = $slots.img;
    if (!img && (t.imgSrc || t.imgBlank)) {
      img = h('b-img', {
        props: {
          fluidGrow: true,
          block: true,
          src: t.imgSrc,
          blank: t.imgBlank,
          blankColor: t.imgBlankColor,
          width: t.computedWidth,
          height: t.computedHeight,
          alt: t.imgAlt
        }
      });
    }

    var content = h(t.contentTag, { class: t.contentClasses }, [t.caption ? h(t.captionTag, { domProps: { innerHTML: t.caption } }) : h(false), t.text ? h(t.textTag, { domProps: { innerHTML: t.text } }) : h(false), $slots.default]);

    return h('div', {
      class: ['carousel-item'],
      style: { background: t.background },
      attrs: { id: t.safeId(), role: 'listitem' }
    }, [img, content]);
  },

  props: {
    imgSrc: {
      type: String,
      default: function _default() {
        if (this && this.src) {
          // Deprecate src
          Object(__WEBPACK_IMPORTED_MODULE_1__utils_warn__["a" /* default */])("b-carousel-slide: prop 'src' has been deprecated. Use 'img-src' instead");
          return this.src;
        }
        return null;
      }
    },
    src: {
      // Deprecated: use img-src instead
      type: String
    },
    imgAlt: {
      type: String
    },
    imgWidth: {
      type: [Number, String]
    },
    imgHeight: {
      type: [Number, String]
    },
    imgBlank: {
      type: Boolean,
      default: false
    },
    imgBlankColor: {
      type: String,
      default: 'transparent'
    },
    contentVisibleUp: {
      type: String
    },
    contentTag: {
      type: String,
      default: 'div'
    },
    caption: {
      type: String
    },
    captionTag: {
      type: String,
      default: 'h3'
    },
    text: {
      type: String
    },
    textTag: {
      type: String,
      default: 'p'
    },
    background: {
      type: String
    }
  },
  computed: {
    contentClasses: function contentClasses() {
      return ['carousel-caption', this.contentVisibleUp ? 'd-none' : '', this.contentVisibleUp ? 'd-' + this.contentVisibleUp + '-block' : ''];
    },
    computedWidth: function computedWidth() {
      // Use local width, or try parent width
      return this.imgWidth || this.$parent.imgWidth;
    },
    computedHeight: function computedHeight() {
      // Use local height, or try parent height
      return this.imgHeight || this.$parent.imgHeight;
    }
  }
});

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".map-wrapper[data-v-0607622b]{width:100%;height:50vh}.dataset .breadcrumb[data-v-0607622b],.nearby .breadcrumb[data-v-0607622b]{padding:0;background-color:unset;margin-bottom:0}.dataset .results .card-columns[data-v-0607622b],.nearby .results .card-columns[data-v-0607622b]{-webkit-column-count:1;-moz-column-count:1;column-count:1}@media (min-width:768px){.dataset .results .card-columns[data-v-0607622b],.nearby .results .card-columns[data-v-0607622b]{-webkit-column-count:2;-moz-column-count:2;column-count:2}}@media (min-width:992px){.dataset .results .card-columns[data-v-0607622b],.nearby .results .card-columns[data-v-0607622b]{-webkit-column-count:3;-moz-column-count:3;column-count:3}}.dataset .results .card[data-v-0607622b],.nearby .results .card[data-v-0607622b]{background-color:unset;border:0}.dataset .results .card .card-body[data-v-0607622b],.nearby .results .card .card-body[data-v-0607622b]{padding:0}", ""]);

// exports


/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.icon)?_c('i',{class:['fa', _vm.icon, 'space-right']}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.phoneNumber))])])}
var staticRenderFns = []


/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Distance_vue__ = __webpack_require__(167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c71503e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Distance_vue__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Distance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c71503e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Distance_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c71503e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Distance_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.icon)?_c('i',{class:['fa', _vm.icon]}):_vm._e(),_vm._v(" "),(_vm.distance === 1)?_c('span',{class:{ 'space-left': _vm.icon }},[_vm._v(_vm._s(_vm.distance)+" mile")]):_c('span',{class:{ 'space-left': _vm.icon }},[_vm._v(_vm._s(_vm.distance)+" miles")])])}
var staticRenderFns = []


/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/// <reference path="../../node_modules/bingmaps/types/MicrosoftMaps/Microsoft.Maps.d.ts" />
/// <reference path="../../node_modules/bingmaps/types/MicrosoftMaps/Modules/Search.d.ts" />
/// <reference path="../../node_modules/bingmaps/types/MicrosoftMaps/Modules/SpatialMath.d.ts" />
/// <reference path="../../node_modules/bingmaps/types/MicrosoftMaps/Modules/SpatialDataService.d.ts" />import { Promise } from "es6-promise";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var MapImpl = /** @class */ (function () {
    function MapImpl(module, native) {
        this.module = module;
        this.native = native;
    }
    MapImpl.prototype.getSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            var module, native;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getSearch(this.module)];
                    case 1:
                        module = _a.sent();
                        native = new module.SearchManager(this.native);
                        return [2 /*return*/, new SearchImpl(module, native, this)];
                }
            });
        });
    };
    MapImpl.prototype.getSpatialData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var module;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getSpatialData(this.module)];
                    case 1:
                        module = _a.sent();
                        return [2 /*return*/, new SpatialDataImpl(module, this)];
                }
            });
        });
    };
    MapImpl.prototype.getSpatialMath = function () {
        return __awaiter(this, void 0, void 0, function () {
            var module;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getSpatialMath(this.module)];
                    case 1:
                        module = _a.sent();
                        return [2 /*return*/, new SpatialMathImpl(module, this)];
                }
            });
        });
    };
    MapImpl.prototype.addCurrentLocationPushpin = function (location) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var position;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!location) return [3 /*break*/, 2];
                        return [4 /*yield*/, getCurrentLocation()];
                    case 1:
                        position = _a.sent();
                        if (position) {
                            location = new this.module.Location(position.coords.latitude, position.coords.longitude);
                        }
                        _a.label = 2;
                    case 2:
                        this.currentLocation = location;
                        if (!this._currentLocationPushpinLayer) {
                            this._currentLocationPushpinLayer = new this.module.Layer("Current Location");
                            this.native.layers.insert(this._currentLocationPushpinLayer);
                        }
                        this._currentLocationPushpinLayer.clear();
                        if (location) {
                            this._currentLocationPushpinLayer.add(this.createFontPushpin(location, '\uF041', undefined, undefined, "blue", function (size) { return new _this.module.Point(size.width / 2, size.height); }));
                        }
                        return [2 /*return*/, location];
                }
            });
        });
    };
    MapImpl.prototype.addPushpin = function (location, options, infoboxOptions) {
        var _this = this;
        if (!this._pushpinLayer) {
            this._pushpinLayer = new this.module.Layer("Pushpins");
            this.native.layers.insert(this._pushpinLayer);
        }
        var pin = new this.module.Pushpin(location, __assign({}, options, { enableHoverStyle: true }));
        this._pushpinLayer.add(pin);
        if (infoboxOptions) {
            this.module.Events.addHandler(pin, "mouseover", function () {
                _this.showInfobox(location, infoboxOptions);
            });
        }
        return pin;
    };
    MapImpl.prototype.clearPushpins = function () {
        this._pushpinLayer && this._pushpinLayer.clear();
    };
    MapImpl.prototype.resetView = function () {
        this.hideInfobox();
        this._currentLocationPushpinLayer && this._currentLocationPushpinLayer.dispose();
        this._currentLocationPushpinLayer = undefined;
        this.clearPushpins();
        this.native.setView({
            mapTypeId: this.module.MapTypeId.road,
            center: new this.module.Location(39.8283, -98.5795),
            zoom: 5
        });
    };
    MapImpl.prototype.setViewToAll = function (locations) {
        locations = locations || (this._pushpinLayer ? this._pushpinLayer.getPrimitives().map(function (p) { return p.getLocation(); }) : []).concat([
            this.currentLocation
        ]).filter(function (p) { return p; });
        if (locations.length === 1) {
            this.native.setView({
                center: locations[0],
                zoom: 10
            });
        }
        else if (locations.length !== 0) {
            this.native.setView({ bounds: this.module.LocationRect.fromLocations(locations) });
        }
    };
    MapImpl.prototype.showInfobox = function (location, options) {
        if (!this._infobox) {
            this._infobox = new this.module.Infobox(new this.module.Location(0, 0), { visible: false });
            this._infobox.setMap(this.native);
        }
        this._infobox.setLocation(location);
        this._infobox.setOptions(__assign({}, options, { visible: true }));
    };
    MapImpl.prototype.hideInfobox = function () {
        if (!this._infobox)
            return;
        this._infobox.setOptions({ visible: false });
    };
    MapImpl.prototype.createFontPushpin = function (location, text, fontName, fontSizePx, color, anchorFn) {
        var _this = this;
        if (fontName === void 0) { fontName = "FontAwesome"; }
        if (fontSizePx === void 0) { fontSizePx = 30; }
        if (color === void 0) { color = "red"; }
        anchorFn = anchorFn || (function (size) { return new _this.module.Point(size.width / 2, size.height / 2); });
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var font = fontSizePx + 'px ' + fontName;
        context.font = font;
        //Resize canvas based on sie of text.
        var size = context.measureText(text);
        canvas.width = size.width;
        canvas.height = fontSizePx;
        //Reset font as it will be cleared by the resize.
        context.font = font;
        context.textBaseline = 'top';
        context.fillStyle = color;
        context.fillText(text, 0, 0);
        return new this.module.Pushpin(location, {
            icon: canvas.toDataURL(),
            anchor: anchorFn({ width: canvas.width, height: canvas.height })
        });
    };
    MapImpl.prototype.dispose = function () {
        this.native.dispose();
        this._currentLocationPushpinLayer && this._currentLocationPushpinLayer.dispose();
        this._pushpinLayer && this._pushpinLayer.dispose();
    };
    return MapImpl;
}());
var SearchImpl = /** @class */ (function () {
    function SearchImpl(module, native, map) {
        this.module = module;
        this.native = native;
        this._map = map;
    }
    SearchImpl.prototype.geocode = function (line1OrWhere, city, state, zip) {
        var _this = this;
        var where = line1OrWhere && city && state && zip
            ? line1OrWhere + ", " + city + ", " + state + " " + zip
            : line1OrWhere;
        var bounds = this._map.native.getBounds();
        bounds.height = bounds.height === 0 ? 1 : bounds.height;
        bounds.width = bounds.width === 0 ? 1 : bounds.width;
        return new Promise(function (resolve, reject) {
            _this.native.geocode({
                bounds: bounds,
                where: where,
                callback: function (result) { return resolve(result); },
                errorCallback: function (options) { return reject(options); }
            });
        });
    };
    return SearchImpl;
}());
// https://msdn.microsoft.com/en-us/library/hh478191.aspx
var itemTypes = {
    "Airport": 4581,
    "Amusement Park": 7996,
    "Animal Park": 9718,
    "ATM": 3578,
    "Auto Dealerships": 5511,
    "Auto Dealership-Used Cars": 5512,
    "Auto Service & Maintenance": 7538,
    "Automobile Club": 8699,
    "Bank": 6000,
    "Bookstore": 9995,
    "Border Crossing": 9999,
    "Bowling Centre": 7933,
    "Bus Station": 4170,
    "Business Facility": 5000,
    "Campground": 9517,
    "Cargo Centre": 9714,
    "Casino": 7985,
    "Cemetery": 9591,
    "Cinema": 7832,
    "City Hall": 9121,
    "Civic/Community Centre": 7994,
    "Clothing Store": 9537,
    "Coffee Shop": 9996,
    "Commuter Rail Station": 4100,
    "Consumer Electronics Store": 9987,
    "Convenience Store": 9535,
    "Convention/Exhibition Centre": 7990,
    "County Council": 9994,
    "Court House": 9211,
    "Department Store": 9545,
    "Embassy": 9993,
    "Ferry Terminal": 4482,
    "Golf Course": 7992,
    "Government Office": 9525,
    "Grocery Store": 5400,
    "Hamlet": 9998,
    "Higher Education": 8200,
    "Highway Exit": 9592,
    "Historical Monument": 5999,
    "Home Improvement & Hardware Store": 9986,
    "Home Specialty Store": 9560,
    "Hospital": 8060,
    "Hotel": 7011,
    "Ice Skating Rink": 7998,
    "Industrial Zone": 9991,
    "Library": 8231,
    "Marina": 4493,
    "Medical Service": 9583,
    "Military Base": 9715,
    "Motorcycle Dealership": 5571,
    "Museum": 8410,
    "Named Place": 4444,
    "Nightlife": 5813,
    "Office Supply & Services Store": 9988,
    "Other Accommodation": 7013,
    "Park & Ride": 7522,
    "Park/Recreation Area": 7947,
    "Parking Garage/House": 7521,
    "Parking Lot": 7520,
    "Performing Arts": 7929,
    "Petrol/Gasoline Station": 5540,
    "Pharmacy": 9565,
    "Place of Worship": 9992,
    "Police Station": 9221,
    "Post Office": 9530,
    "Public Sports Airport": 4580,
    "Rental Car Agency": 7510,
    "Residential Area/Building": 9590,
    "Rest Area": 7897,
    "Restaurant": 5800,
    "School": 8211,
    "Shopping": 6512,
    "Ski Lift": 7014,
    "Ski Resort": 7012,
    "Specialty Store": 9567,
    "Sporting Goods Store": 9568,
    "Sports Centre": 7997,
    "Sports Complex": 7940,
    "Tourist Attraction": 7999,
    "Tourist Information": 7389,
    "Train Station": 4013,
    "Transportation Service": 9593,
    "Truck Dealership": 9719,
    "Truck Stop/Plaza": 9522,
    "Weigh Station": 9710,
    "Winery": 2084
};
var SpatialDataImpl = /** @class */ (function () {
    function SpatialDataImpl(module, map) {
        this.module = module;
        this._map = map;
    }
    SpatialDataImpl.prototype.nearby = function (term, radius) {
        var _this = this;
        if (radius === void 0) { radius = 25; }
        return new Promise(function (resolve, reject) {
            _this.module.QueryAPIManager.search({
                queryUrl: "//spatial.virtualearth.net/REST/v1/data/f22876ec257b474b82fe2ffcb8393150/NavteqNA/NavteqPOIs",
                filter: "EntityTypeID eq '" + itemTypes[term] + "'",
                inlineCount: true,
                spatialFilter: {
                    spatialFilterType: "nearby",
                    location: _this._map.currentLocation,
                    radius: radius
                }
            }, _this._map.native, function (data, inlineCount) {
                resolve({ data: data, total: inlineCount });
            }, undefined, function (networkStatus, statusMessage) {
                reject(statusMessage);
            });
        });
    };
    return SpatialDataImpl;
}());
var SpatialMathImpl = /** @class */ (function () {
    function SpatialMathImpl(module, map) {
        this.module = module;
        this._map = map;
    }
    SpatialMathImpl.prototype.getDistanceTo = function (origin, destination, units, highAccuracy) {
        return this.module.getDistanceTo(origin, destination, units, highAccuracy);
    };
    return SpatialMathImpl;
}());
function create(apiKey, parentElement, scriptSrc) {
    return __awaiter(this, void 0, void 0, function () {
        var module, native, map;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getModule(scriptSrc)];
                case 1:
                    module = _a.sent();
                    native = new module.Map(parentElement, {
                        credentials: apiKey,
                        mapTypeId: module.MapTypeId.road,
                        navigationBarMode: module.NavigationBarMode.compact
                    });
                    map = new MapImpl(module, native);
                    map.resetView();
                    return [2 /*return*/, map];
            }
        });
    });
}
// =======================================================
// Helpers
// =======================================================
var _cachedCurrentLocation;
function getCurrentLocation() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    if (_cachedCurrentLocation) {
                        resolve(_cachedCurrentLocation);
                    }
                    navigator.geolocation.getCurrentPosition(function (position) {
                        _cachedCurrentLocation = position;
                        resolve(_cachedCurrentLocation);
                    }, function (error) {
                        if (error.code === error.PERMISSION_DENIED) {
                            resolve(undefined);
                        }
                        else {
                            reject(error);
                        }
                    });
                })];
        });
    });
}
// =======================================================
// Module initialization
// =======================================================
var initalizeCallbackName = "__helpers_BingMaps_initialize__";
var getModulePromise;
function getModule(src) {
    if (getModulePromise)
        return getModulePromise;
    src = src || "//www.bing.com/api/maps/mapcontrol?branch=release";
    src += src.indexOf('?') === -1
        ? '?'
        : '&';
    src += "callback=" + initalizeCallbackName;
    return getModulePromise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = src;
        script.onerror = function () {
            reject("Could not load script '" + src + "'");
        };
        window[initalizeCallbackName] = function () {
            window[initalizeCallbackName] = undefined;
            if (!window.Microsoft || !window.Microsoft.Maps) {
                reject("Error parsing script '" + src + "'");
                return;
            }
            resolve(window.Microsoft.Maps);
        };
        document.body.appendChild(script);
    });
}
var getSearchPromise;
function getSearch(module) {
    if (getSearchPromise)
        return getSearchPromise;
    return getSearchPromise = new Promise(function (resolve, reject) {
        module.loadModule("Microsoft.Maps.Search", {
            callback: function () { return resolve(window.Microsoft.Maps.Search); },
            errorCallback: function () { return reject("Could not load 'Microsoft.Maps.Search'"); }
        });
    });
}
var getSpatialDataPromise;
function getSpatialData(module) {
    if (getSpatialDataPromise)
        return getSpatialDataPromise;
    return getSpatialDataPromise = new Promise(function (resolve, reject) {
        module.loadModule("Microsoft.Maps.SpatialDataService", {
            callback: function () { return resolve(window.Microsoft.Maps.SpatialDataService); },
            errorCallback: function () { return reject("Could not load 'Microsoft.Maps.SpatialDataService'"); }
        });
    });
}
var getSpatialMathPromise;
function getSpatialMath(module) {
    if (getSpatialDataPromise)
        return getSpatialMathPromise;
    return getSpatialMathPromise = new Promise(function (resolve, reject) {
        module.loadModule("Microsoft.Maps.SpatialMath", {
            callback: function () { return resolve(window.Microsoft.Maps.SpatialMath); },
            errorCallback: function () { return reject("Could not load 'Microsoft.Maps.SpatialMath'"); }
        });
    });
}


/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.rendered && (_vm.useLocationSearch || _vm.useRadius))?_c('div',{staticClass:"location"},[_c('b-row',[(_vm.useLocationSearch)?_c('b-col',{attrs:{"cols":"8"}},[_c('input-group',[(_vm.useGps && _vm.canUseGps)?_c('input-group-addon',[_c('button',{class:['btn', { 'btn-primary': _vm.isGps }],on:{"click":_vm.onGpsClick}},[_c('i',{staticClass:"fa fa-crosshairs"})])]):_vm._e(),_vm._v(" "),_c('form-input',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.focus",modifiers:{"focus":true}}],ref:"locationSearch",attrs:{"type":"text","placeholder":"Search by address, city or zip","title":_vm.locationSearchError},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.onLocationSearchClick($event)}},model:{value:(_vm.locationSearchText),callback:function ($$v) {_vm.locationSearchText=$$v},expression:"locationSearchText"}}),_vm._v(" "),_c('div',{class:['dropdown-menu', { show: _vm.locationSearchResults.length !== 0 }]},_vm._l((_vm.locationSearchResults),function(result,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onLocationSearchResultClick(result)}}},[_vm._v(_vm._s(result.name))])})),_vm._v(" "),_c('input-group-addon',{attrs:{"append":""}},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.onLocationSearchClick}},[_c('i',{staticClass:"fa fa-search"})])])],1)],1):_vm._e(),_vm._v(" "),(_vm.useRadius)?_c('b-col',{attrs:{"cols":"4"}},[_c('form-select',{staticClass:"custom-select",on:{"change":_vm.sortAndFilterDataset},model:{value:(_vm.localRadius),callback:function ($$v) {_vm.localRadius=$$v},expression:"localRadius"}},_vm._l((_vm.radii),function(radius,index){return _c('option',{key:index,domProps:{"value":radius.value}},[_vm._v(_vm._s(radius.text))])}))],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"map-wrapper"},[_c('div',{ref:"root",staticClass:"map"})]),_vm._v(" "),(_vm.rendered && _vm.nearby.length !== 0)?_c('div',{staticClass:"nearby"},[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('h6',{staticClass:"d-inline"},[_vm._v("Search Nearby:")])]),_vm._v(" "),_c('b-col',[_c('b-breadcrumb',[_vm._l((_vm.nearby),function(term,index){return _c('b-breadcrumb-item',{key:index,attrs:{"text":typeof term === 'string' ? term : term.text,"active":term === _vm.activeNearby},on:{"click":function($event){$event.preventDefault();_vm.searchNearby(term)}}})}),_vm._v(" "),_c('b-breadcrumb-item',{attrs:{"text":"Clear"},on:{"click":function($event){$event.preventDefault();_vm.resetNearby($event)}}})],2)],1)],1),_vm._v(" "),(_vm.rendered && _vm.nearbyResults.length !== 0)?_c('div',{staticClass:"results"},[_c('b-card-group',{attrs:{"columns":""}},[_vm._l((_vm.nearbyResults),function(result,index){return _c('b-card',{key:index},[_c('div',{class:{ active: result === _vm.activeNearbyResult }},[_c('a',{attrs:{"href":'https://www.bing.com/maps?q=' + _vm.location.line1 + ', ' + _vm.location.city + ', ' + _vm.location.state + ' ' + _vm.location.zip + ' to ' + result.address.line1 + ', ' + result.address.city + ', ' + result.address.state + ' ' + result.address.zip,"target":"_blank"},on:{"mouseenter":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.overNearby(result)},"mouseout":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.outNearby(result)}}},[_c('span',{staticClass:"h4"},[_vm._v(_vm._s(index + 1)+". "+_vm._s(result.address.title))])]),_vm._v(" "),_c('div',{staticClass:"text-muted",on:{"mouseenter":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.overNearby(result)},"mouseout":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.outNearby(result)},"click":function($event){_vm.overNearby(result)}}},[(result.distance)?_c('em',{staticClass:"d-block"},[_c('distance',{attrs:{"value":result.distance,"precision":1}})],1):_vm._e(),_vm._v(" "),(result.address.line1)?_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(result.address.line1))]):_vm._e(),_vm._v(" "),(result.address.phoneNumber)?_c('span',{staticClass:"d-block"},[_c('phone-number',{attrs:{"value":result.address.phoneNumber}})],1):_vm._e()])])])}),_vm._v(" "),(_vm.nearbyResultsTotal > _vm.nearbyResults.length)?_c('b-card',[_c('div',{staticClass:"more"},[_c('a',{attrs:{"href":'https://www.bing.com/maps?q=' + _vm.activeNearby.term + ' near ' + _vm.location.line1 + ', ' + _vm.location.city + ', ' + _vm.location.state + ' ' + _vm.location.zip,"target":"_blank"}},[_c('span',{staticClass:"h5"},[_vm._v("More")])])])]):_vm._e()],2)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.showAddressesList && _vm.addresses.length !== 0)?_c('div',{staticClass:"dataset"},[(_vm.rendered && _vm.datasetResults.length !== 0)?_c('div',{staticClass:"results"},[_c('b-card-group',{attrs:{"columns":""}},_vm._l((_vm.datasetResults),function(result,index){return _c('b-card',{key:index},[_c('div',{class:{ active: result === _vm.activeDatasetResult }},[_c('a',{attrs:{"href":result.address.url},on:{"mouseenter":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.overDatasetResult(result)},"mouseout":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.outDatasetResult(result)}}},[_c('span',{staticClass:"h4"},[_vm._v(_vm._s(index + 1)+". "+_vm._s(result.address.title))])]),_vm._v(" "),_c('div',{staticClass:"text-muted",on:{"mouseenter":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.overDatasetResult(result)},"mouseout":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.outDatasetResult(result)},"click":function($event){_vm.overDatasetResult(result)}}},[(result.distance)?_c('em',{staticClass:"d-block"},[_c('distance',{attrs:{"value":result.distance}})],1):_vm._e(),_vm._v(" "),(result.address.line1)?_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(result.address.line1))]):_vm._e(),_vm._v(" "),(result.address.line2)?_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(result.address.line2))]):_vm._e(),_vm._v(" "),(result.address.city && result.address.state && result.address.zip)?_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(result.address.city)+", "+_vm._s(result.address.state)+" "+_vm._s(result.address.zip))]):_vm._e()])])])}))],1):_vm._e()]):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(267);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("43b2a242", content, true, {});

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".coordinators[data-v-27aadde0]{margin:-15px}.coordinators li[data-v-27aadde0]{margin:15px;vertical-align:top}.hr[data-v-27aadde0]{width:50%}", ""]);

// exports


/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactInformation_vue__ = __webpack_require__(169);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79bd23de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactInformation_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactInformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79bd23de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactInformation_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79bd23de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactInformation_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailAddress_vue__ = __webpack_require__(170);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fc5708c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailAddress_vue__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fc5708c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailAddress_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fc5708c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailAddress_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__breadcrumb_item__ = __webpack_require__(9);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






var props = {
  items: {
    type: Array,
    default: null
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var childNodes = children;
    // Build child nodes from items if given.
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["d" /* isArray */])(props.items)) {
      var activeDefined = false;
      childNodes = props.items.map(function (item, idx) {
        if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) !== 'object') {
          item = { text: item };
        }
        // Copy the value here so we can normalize it.
        var active = item.active;
        if (active) {
          activeDefined = true;
        }
        if (!active && !activeDefined) {
          // Auto-detect active by position in list.
          active = idx + 1 === props.items.length;
        }

        return h(__WEBPACK_IMPORTED_MODULE_3__breadcrumb_item__["a" /* default */], { props: Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])({}, item, { active: active }) });
      });
    }

    return h('ol', Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, { staticClass: 'breadcrumb' }), childNodes);
  }
});

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.icon)?_c('i',{class:['fa', _vm.icon, 'space-right']}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":_vm.href}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []


/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.profile)?_c('span',{staticClass:"d-block text-center profile-picture"},[_c('profile-picture',_vm._b({attrs:{"size":"lg"}},'profile-picture',_vm.profile,false))],1):_vm._e(),_vm._v(" "),(_vm.profile)?_c('span',{staticClass:"d-block"},[_c('strong',[_vm._v(_vm._s(_vm.profile.fullName))])]):_vm._e(),_vm._v(" "),(_vm.email)?_c('span',{staticClass:"d-block"},[_c('email-address',{attrs:{"value":_vm.email,"subject":_vm.emailSubject}})],1):_vm._e(),_vm._v(" "),(_vm.phoneNumber)?_c('span',{staticClass:"d-block"},[_c('phone-number',{attrs:{"value":_vm.phoneNumber}})],1):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.coordinators.length !== 0)?_c('div',[_vm._t("header",[(_vm.coordinators.length === 1)?_c('span',[_vm._v("Contact the coordinator:")]):_c('span',[_vm._v("Contact one of the coordinators:")])]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled list-inline coordinators"},_vm._l((_vm.coordinators),function(coordinator,index){return _c('li',{key:index,staticClass:"list-inline-item"},[_c('contact-information',_vm._b({attrs:{"email-subject":_vm.emailSubject}},'contact-information',coordinator.member,false))],1)}))],2):_vm._e(),_vm._v(" "),(_vm.coordinators.length !== 0 && (_vm.generalEmail || _vm.generalPhoneNumber))?_c('div',{staticClass:"hr"},[_c('span',[_vm._v("or")])]):_vm._e(),_vm._v(" "),(_vm.generalEmail || _vm.generalPhoneNumber)?_c('contact-information',{attrs:{"email":_vm.generalEmail,"email-subject":_vm.emailSubject,"phone-number":_vm.generalPhoneNumber}}):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rate_vue__ = __webpack_require__(171);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dbd87cc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rate_vue__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(274)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8dbd87cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dbd87cc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dbd87cc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(275);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("62c62c3c", content, true, {});

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".unavailable[data-v-8dbd87cc]{opacity:.4}", ""]);

// exports


/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{class:{ unavailable: _vm.unavailable }},[_c('b-col',[_c('strong',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),(_vm.note)?_c('em',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.note))]):_vm._e(),_vm._v(" "),(_vm.type === 'age')?_c('span',{staticClass:"d-block"},[(_vm.minAge && _vm.maxAge)?_c('em',[_vm._v("between the ages of "+_vm._s(_vm.minAge)+" and "+_vm._s(_vm.maxAge))]):(_vm.minAge)?_c('em',[_vm._v(_vm._s(_vm.minAge)+" years and older")]):(_vm.maxAge)?_c('em',[_vm._v(_vm._s(_vm.maxAge)+" years and younger")]):_vm._e()]):(_vm.type === 'date')?_c('span',{staticClass:"d-block"},[(_vm.localStart && _vm.localEnd)?_c('em',[_vm._v("paid between "+_vm._s(_vm.localStart.format(_vm.dateFormat))+" and "+_vm._s(_vm.localEnd.format(_vm.dateFormat)))]):(_vm.localStart)?_c('em',[_vm._v("paid on or after "+_vm._s(_vm.localStart.format(_vm.dateFormat)))]):(_vm.localEnd)?_c('em',[_vm._v("paid on or before "+_vm._s(_vm.localEnd.format(_vm.dateFormat)))]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('b-col',[(_vm.isFree === true)?_c('strong',{staticClass:"d-block text-uppercase"},[_vm._v("Free")]):_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(_vm.price)))]),_vm._v(" "),(_vm.priceNote)?_c('em',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.priceNote))]):_vm._e()])],1)}
var staticRenderFns = []


/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var props = {
  disabled: {
    type: Boolean,
    default: false
  },
  ariaLabel: {
    type: String,
    default: 'Close'
  },
  textVariant: {
    type: String,
    default: null
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        listeners = _ref.listeners,
        slots = _ref.slots;

    var componentData = {
      staticClass: 'close',
      class: _defineProperty({}, 'text-' + props.textVariant, props.textVariant),
      attrs: {
        type: 'button',
        disabled: props.disabled,
        'aria-label': props.ariaLabel ? String(props.ariaLabel) : null
      },
      on: {
        click: function click(e) {
          // Ensure click on button HTML content is also disabled
          if (props.disabled && e instanceof Event) {
            e.stopPropagation();
            e.preventDefault();
          }
        }
      }
      // Careful not to override the slot with innerHTML
    };if (!slots().default) {
      componentData.domProps = { innerHTML: '&times;' };
    }
    return h('button', Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, componentData), slots().default);
  }
});

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cover_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d087a9d0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cover_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(33)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d087a9d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d087a9d0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cover_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d087a9d0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cover_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(34);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("cba5045c", content, true, {});

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".fade-enter-active[data-v-d087a9d0],.fade-leave-active[data-v-d087a9d0]{transition:opacity 1s}.fade-enter[data-v-d087a9d0],.fade-leave-to[data-v-d087a9d0]{opacity:0}.jumbotron[data-v-d087a9d0]{position:relative;overflow-x:hidden;border-radius:0;margin-left:-15px;margin-right:-15px}.jumbotron .overlay[data-v-d087a9d0]{background-color:rgba(0,0,0,.4)!important;color:#fff!important}.jumbotron .overlay hr[data-v-d087a9d0]{border-top:1px solid hsla(0,0%,100%,.4)!important}.jumbotron .overlay .breadcrumb-item a[data-v-d087a9d0],.jumbotron .overlay .hashtags[data-v-d087a9d0]{color:#fff!important}.jumbotron .content[data-v-d087a9d0]{position:relative;margin:0 -2rem;padding:0 2rem}.jumbotron .breakout[data-v-d087a9d0]{position:absolute;bottom:0;left:0;right:0;padding-bottom:1rem}.jumbotron .breakout .breadcrumb[data-v-d087a9d0]{padding:0;margin:0;padding-left:2rem;padding-right:1rem;background-color:unset}.jumbotron .breakout .hashtags[data-v-d087a9d0]{color:#00bcd4;font-size:1.25rem;margin:0;padding-right:1rem;padding-left:1rem}.jumbotron .carousel[data-v-d087a9d0] .carousel-inner{position:absolute;width:100%;height:100%}@media (max-width:991.98px){.jumbotron .carousel[data-v-d087a9d0] .carousel-caption,.jumbotron .carousel[data-v-d087a9d0] .carousel-indicators{display:none}}.jumbotron .testimonial[data-v-d087a9d0]{position:absolute;top:0;bottom:0;left:50%;right:2rem;white-space:nowrap;text-align:right;color:#fff}.jumbotron .testimonial[data-v-d087a9d0]:before{content:\"\";display:inline-block;height:100%;vertical-align:middle}.jumbotron .testimonial>[data-v-d087a9d0]{display:inline-block;vertical-align:middle;white-space:normal}", ""]);

// exports


/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(36);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("1073e16a", content, true, {});

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "img[data-v-0fe4156c]{object-fit:cover}", ""]);

// exports


/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img-fluid",style:({ objectPosition: ((_vm.convertToPercent(_vm.focalPoint ? _vm.focalPoint.left : 0.5)) + " " + (_vm.convertToPercent(_vm.focalPoint ? _vm.focalPoint.top : 0.5))) }),attrs:{"src":_vm.src,"srcset":_vm.srcset}})}
var staticRenderFns = []


/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Testimonial_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17bd6665_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Testimonial_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(39)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17bd6665"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Testimonial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17bd6665_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Testimonial_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17bd6665_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Testimonial_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(40);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("480bd88c", content, true, {});

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".root[data-v-17bd6665]{text-align:center}.root .author-title[data-v-17bd6665],.root .author[data-v-17bd6665]{text-align:right}", ""]);

// exports


/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"root"},[_c('em',{staticClass:"d-block lead text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('span',{staticClass:"d-block author"},[_vm._v("—"+_vm._s(_vm.author))]),_vm._v(" "),(_vm.authorTitle)?_c('span',{staticClass:"d-block author-title"},[_vm._v(_vm._s(_vm.authorTitle))]):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__link_link__ = __webpack_require__(24);





var props = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])(Object(__WEBPACK_IMPORTED_MODULE_3__link_link__["b" /* propsFactory */])(), {
  text: {
    type: String,
    default: null
  },
  active: {
    type: Boolean,
    default: false
  },
  href: {
    type: String,
    default: '#'
  },
  ariaCurrent: {
    type: String,
    default: 'location'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var suppliedProps = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var tag = suppliedProps.active ? 'span' : __WEBPACK_IMPORTED_MODULE_3__link_link__["a" /* default */];

    var componentData = {
      props: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__["a" /* default */])(props, suppliedProps),
      domProps: { innerHTML: suppliedProps.text }
    };

    if (suppliedProps.active) {
      componentData.attrs = { 'aria-current': suppliedProps.ariaCurrent };
    } else {
      componentData.attrs = { href: suppliedProps.href };
    }

    return h(tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, componentData), children);
  }
});

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// Blank image with fill template
var BLANK_TEMPLATE = '<svg width="%{w}" height="%{h}" ' + 'xmlns="http://www.w3.org/2000/svg" ' + 'viewBox="0 0 %{w} %{h}" preserveAspectRatio="none">' + '<rect width="100%" height="100%" style="fill:%{f};"></rect>' + '</svg>';

function makeBlankImgSrc(width, height, color) {
  var src = encodeURIComponent(BLANK_TEMPLATE.replace('%{w}', String(width)).replace('%{h}', String(height)).replace('%{f}', color));
  return 'data:image/svg+xml;charset=UTF-8,' + src;
}

var props = {
  src: {
    type: String,
    default: null
  },
  alt: {
    type: String,
    default: null
  },
  width: {
    type: [Number, String],
    default: null
  },
  height: {
    type: [Number, String],
    default: null
  },
  block: {
    type: Boolean,
    default: false
  },
  fluid: {
    type: Boolean,
    default: false
  },
  fluidGrow: {
    // Gives fluid images class `w-100` to make them grow to fit container
    type: Boolean,
    default: false
  },
  rounded: {
    // rounded can be:
    //   false: no rounding of corners
    //   true: slightly rounded corners
    //   'top': top corners rounded
    //   'right': right corners rounded
    //   'bottom': bottom corners rounded
    //   'left': left corners rounded
    //   'circle': circle/oval
    //   '0': force rounding off
    type: [Boolean, String],
    default: false
  },
  thumbnail: {
    type: Boolean,
    default: false
  },
  left: {
    type: Boolean,
    default: false
  },
  right: {
    type: Boolean,
    default: false
  },
  center: {
    type: Boolean,
    default: false
  },
  blank: {
    type: Boolean,
    default: false
  },
  blankColor: {
    type: String,
    default: 'transparent'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var props = _ref.props,
        data = _ref.data;

    var src = props.src;
    var width = parseInt(props.width, 10) ? parseInt(props.width, 10) : null;
    var height = parseInt(props.height, 10) ? parseInt(props.height, 10) : null;
    var align = null;
    var block = props.block;
    if (props.blank) {
      if (!height && Boolean(width)) {
        height = width;
      } else if (!width && Boolean(height)) {
        width = height;
      }
      if (!width && !height) {
        width = 1;
        height = 1;
      }
      // Make a blank SVG image
      src = makeBlankImgSrc(width, height, props.blankColor || 'transparent');
    }
    if (props.left) {
      align = 'float-left';
    } else if (props.right) {
      align = 'float-right';
    } else if (props.center) {
      align = 'mx-auto';
      block = true;
    }
    return h('img', Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      attrs: {
        'src': src,
        'alt': props.alt,
        'width': width ? String(width) : null,
        'height': height ? String(height) : null
      },
      class: (_class = {
        'img-thumbnail': props.thumbnail,
        'img-fluid': props.fluid || props.fluidGrow,
        'w-100': props.fluidGrow,
        'rounded': props.rounded === '' || props.rounded === true
      }, _defineProperty(_class, 'rounded-' + props.rounded, typeof props.rounded === 'string' && props.rounded !== ''), _defineProperty(_class, align, Boolean(align)), _defineProperty(_class, 'd-block', block), _class)
    }));
  }
});

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[(_vm.imagesArray.length === 1)?_c('responsive-image',_vm._b({staticClass:"position-absolute fill"},'responsive-image',_vm.imagesArray[0],false)):(_vm.imagesArray.length > 1)?_c('b-carousel',{ref:"carousel",staticClass:"position-absolute fill",attrs:{"indicators":""},on:{"sliding-start":_vm.carouselSliding}},_vm._l((_vm.imagesArray),function(image,index){return _c('b-carousel-slide',{key:index,staticClass:"position-absolute fill"},[_c('responsive-image',_vm._b({staticClass:"position-absolute fill",attrs:{"slot":"img"},slot:"img"},'responsive-image',image,false))],1)})):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content",class:{ overlay: _vm.imagesArray.length !== 0}},[_vm._t("title",[_c('h1',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_vm._t("description",[(_vm.shortDescription)?_c('p',{staticClass:"lead"},[_vm._v(_vm._s(_vm.shortDescription))]):_vm._e()]),_vm._v(" "),(_vm.hrVisible)?_c('hr',{staticClass:"my-2"}):_vm._e(),_vm._v(" "),_vm._t("default",[(_vm.longDescription)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.longDescription)}}):_vm._e()])],2),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.testimonial1)?_c('div',{key:"testimonial1",staticClass:"testimonial"},[_c('testimonial',_vm._b({},'testimonial',_vm.testimonial1,false))],1):(_vm.testimonial2)?_c('div',{key:"testimonial2",staticClass:"testimonial"},[_c('testimonial',_vm._b({},'testimonial',_vm.testimonial2,false))],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"breakout"},[_c('b-row',{staticClass:"clearfix"},[_c('b-col',{attrs:{"cols":"12","lg":"6","order":"12","order-lg":"1"}},[(_vm.breadcrumbs.length !== 0)?_c('b-breadcrumb',{class:['pull-left', { overlay: _vm.imagesArray.length !== 0}]},_vm._l((_vm.breadcrumbs),function(breadcrumb,index){return _c('b-breadcrumb-item',{key:index,class:[ breadcrumb.getAttribute('breadcrumb-link-class') ],attrs:{"href":'#' + breadcrumb.id,"text":breadcrumb.getAttribute('breadcrumb-title')}})})):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","lg":"6","order":"1","order-lg":"12"}},[(_vm.hashtags.length !== 0)?_c('div',{class:['pull-right', 'text-right', { overlay: _vm.imagesArray.length !== 0}]},[_vm._t("hashtags",[(_vm.hashtags.length !== 0)?_c('ul',{staticClass:"list-inline hashtags"},_vm._l((_vm.hashtags),function(hashtag){return _c('li',{key:hashtag,staticClass:"list-inline-item"},[_vm._v(_vm._s(hashtag))])})):_vm._e()])],2):_vm._e()])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button_button_close__ = __webpack_require__(31);


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { bButtonClose: __WEBPACK_IMPORTED_MODULE_0__button_button_close__["a" /* default */] },
  render: function render(h) {
    if (!this.localShow) {
      // If not showing, render placeholder
      return h(false);
    }
    var dismissBtn = h(false);
    if (this.dismissible) {
      // Add dismiss button
      dismissBtn = h('b-button-close', { attrs: { 'aria-label': this.dismissLabel }, on: { click: this.dismiss } }, [this.$slots.dismiss]);
    }
    return h('div', { class: this.classObject, attrs: { role: 'alert', 'aria-live': 'polite', 'aria-atomic': true } }, [dismissBtn, this.$slots.default]);
  },

  model: {
    prop: 'show',
    event: 'input'
  },
  data: function data() {
    return {
      countDownTimerId: null,
      dismissed: false
    };
  },

  computed: {
    classObject: function classObject() {
      return ['alert', this.alertVariant, this.dismissible ? 'alert-dismissible' : ''];
    },
    alertVariant: function alertVariant() {
      var variant = this.variant;
      return 'alert-' + variant;
    },
    localShow: function localShow() {
      return !this.dismissed && (this.countDownTimerId || this.show);
    }
  },
  props: {
    variant: {
      type: String,
      default: 'info'
    },
    dismissible: {
      type: Boolean,
      default: false
    },
    dismissLabel: {
      type: String,
      default: 'Close'
    },
    show: {
      type: [Boolean, Number],
      default: false
    }
  },
  watch: {
    show: function show() {
      this.showChanged();
    }
  },
  mounted: function mounted() {
    this.showChanged();
  },
  destroyed /* istanbul ignore next */: function destroyed() {
    this.clearCounter();
  },

  methods: {
    dismiss: function dismiss() {
      this.clearCounter();
      this.dismissed = true;
      this.$emit('dismissed');
      this.$emit('input', false);
      if (typeof this.show === 'number') {
        this.$emit('dismiss-count-down', 0);
        this.$emit('input', 0);
      } else {
        this.$emit('input', false);
      }
    },
    clearCounter: function clearCounter() {
      if (this.countDownTimerId) {
        clearInterval(this.countDownTimerId);
        this.countDownTimerId = null;
      }
    },
    showChanged: function showChanged() {
      var _this = this;

      // Reset counter status
      this.clearCounter();
      // Reset dismiss status
      this.dismissed = false;
      // No timer for boolean values
      if (this.show === true || this.show === false || this.show === null || this.show === 0) {
        return;
      }
      // Start counter
      var dismissCountDown = this.show;
      this.countDownTimerId = setInterval(function () {
        if (dismissCountDown < 1) {
          _this.dismiss();
          return;
        }
        dismissCountDown--;
        _this.$emit('dismiss-count-down', dismissCountDown);
        _this.$emit('input', dismissCountDown);
      }, 1000);
    }
  }
});

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertList_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce6f1ca6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertList_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(47)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce6f1ca6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce6f1ca6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce6f1ca6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(48);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("0e518b28", content, true, {});

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".alert-list[data-v-ce6f1ca6]{margin-left:-15px;margin-right:-15px}.alert-list .alert[data-v-ce6f1ca6],.alert-list .alert[data-v-ce6f1ca6] ol:last-of-type,.alert-list .alert[data-v-ce6f1ca6] ul:last-of-type{margin-bottom:0}.jumbotron~.alert-list[data-v-ce6f1ca6]{margin-top:-2rem;margin-bottom:2rem}.jumbotron~.alert-list[data-v-ce6f1ca6]:empty{margin-top:unset;margin-bottom:unset}", ""]);

// exports


/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-list"},[_vm._t("default",_vm._l((_vm.localValue),function(alert,index){return _c('alert',_vm._b({key:index},'alert',alert,false),[_c('span',{domProps:{"innerHTML":_vm._s(alert.text)}})])}))],2)}
var staticRenderFns = []


/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = prefixPropName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__upper_first__ = __webpack_require__(146);


/**
 * @param {string} prefix
 * @param {string} value
 */
function prefixPropName(prefix, value) {
  return prefix + Object(__WEBPACK_IMPORTED_MODULE_0__upper_first__["a" /* default */])(value);
}

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = copyProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__object__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(21);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





/**
 * @param {[]|{}} props
 * @param {Function} transformFn
 */
function copyProps(props) {
  var transformFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */];

  if (Object(__WEBPACK_IMPORTED_MODULE_0__array__["d" /* isArray */])(props)) {
    return props.map(transformFn);
  }
  // Props as an object.
  var copied = {};

  for (var prop in props) {
    if (props.hasOwnProperty(prop)) {
      if ((typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) === 'object') {
        copied[transformFn(prop)] = Object(__WEBPACK_IMPORTED_MODULE_1__object__["a" /* assign */])({}, props[prop]);
      } else {
        copied[transformFn(prop)] = props[prop];
      }
    }
  }

  return copied;
}

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    bgVariant: {
      type: String,
      default: null
    },
    borderVariant: {
      type: String,
      default: null
    },
    textVariant: {
      type: String,
      default: null
    }
  }
});

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var BreadcrumbAnchor = /** @class */ (function (_super) {
    __extends(BreadcrumbAnchor, _super);
    function BreadcrumbAnchor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BreadcrumbAnchor.prototype, "safeId", {
        get: function () {
            var id = this.id || this.title;
            return id
                .replace(/\s*/g, '')
                .replace(/[^A-Z0-9_|\-|\:|\.]/gi, '');
        },
        enumerable: true,
        configurable: true
    });
    BreadcrumbAnchor.prototype.mounted = function () {
        window.$bus.$emit("BreadcrumbAnchor.mounted");
    };
    BreadcrumbAnchor.prototype.unmounted = function () {
        window.$bus.$emit("BreadcrumbAnchor.unmounted");
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], BreadcrumbAnchor.prototype, "id", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String, required: true })
    ], BreadcrumbAnchor.prototype, "title", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], BreadcrumbAnchor.prototype, "linkClass", void 0);
    BreadcrumbAnchor = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "BreadcrumbAnchor"
        })
    ], BreadcrumbAnchor);
    return BreadcrumbAnchor;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbAnchor);
;


/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Card.prototype, "localStart", {
        get: function () { return (this.start && __WEBPACK_IMPORTED_MODULE_1_moment__["isMoment"](this.start)) ? this.start : parseDate(this.start); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Card.prototype, "now", {
        get: function () { return __WEBPACK_IMPORTED_MODULE_1_moment__(__WEBPACK_IMPORTED_MODULE_1_moment__["now"]()); },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Card.prototype, "registerUrl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Card.prototype, "registrationUrl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Boolean, default: false })
    ], Card.prototype, "registered", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Boolean, default: false })
    ], Card.prototype, "full", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: [__WEBPACK_IMPORTED_MODULE_1_moment__, String] })
    ], Card.prototype, "start", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String, default: "MMMM D, YYYY" })
    ], Card.prototype, "dateFormat", void 0);
    Card = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "Card",
            components: {}
        })
    ], Card);
    return Card;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Card);
;
function parseDate(value) {
    return value
        ? __WEBPACK_IMPORTED_MODULE_1_moment__(value)
        : undefined;
}


/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_es_components_card_card__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Background_vue__ = __webpack_require__(65);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Card.prototype, "title", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Card.prototype, "subtitle", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Card.prototype, "badge", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Card.prototype, "content", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Card.prototype, "footer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Card.prototype, "downloadLink", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Card.prototype, "contentLink", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Card.prototype, "externalLink", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Card.prototype, "externalLinkText", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Object })
    ], Card.prototype, "background", void 0);
    Card = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "Card",
            components: {
                "b-card": __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_es_components_card_card__["a" /* default */],
                Background: __WEBPACK_IMPORTED_MODULE_2__Background_vue__["a" /* default */]
            }
        })
    ], Card);
    return Card;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Card);
;


/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Background_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43cc4def_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Background_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(106)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43cc4def"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Background_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43cc4def_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Background_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43cc4def_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Background_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var Background = /** @class */ (function (_super) {
    __extends(Background, _super);
    function Background() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Background.prototype, "position", {
        get: function () { return (this.horizontalPosition || '') + " " + (this.verticalPosition || ''); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Background.prototype, "backgroundStyleObj", {
        get: function () { return parseStyle(this.backgroundStyle); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Background.prototype, "overlayStyleObj", {
        get: function () { return parseStyle(this.overlayStyle); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Background.prototype, "gradient", {
        get: function () {
            var key = "gradient:";
            var effect = (this.effect || "").toLowerCase();
            return effect.indexOf("gradient:") === 0
                ? "linear-gradient(to " + effect.substring(key.length).trim() + ", " + (this.color || 'transparent') + ", " + (this.secondaryColor || 'transparent') + ")"
                : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Background.prototype, "image", {
        get: function () {
            return this.imageUrl
                ? "url('" + this.imageUrl + "')"
                : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Background.prototype, "backgroundImage", {
        get: function () {
            return (this.image && this.gradient && !this.imageEffect ? this.image + ", " + this.gradient : null)
                || this.image
                || (!this.imageEffect ? this.gradient : null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Background.prototype, "backgroundColor", {
        get: function () {
            return !this.backgroundImage || this.image
                ? this.color
                : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Background.prototype, "overlayBackgroundImage", {
        get: function () {
            return (this.imageEffect ? this.gradient : null);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Boolean, default: false })
    ], Background.prototype, "page", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Background.prototype, "color", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Background.prototype, "secondaryColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Background.prototype, "imageUrl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Background.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Background.prototype, "horizontalPosition", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Background.prototype, "verticalPosition", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Background.prototype, "effect", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Boolean, default: false })
    ], Background.prototype, "imageEffect", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Background.prototype, "backgroundStyle", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], Background.prototype, "overlayStyle", void 0);
    Background = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "Background"
        })
    ], Background);
    return Background;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Background);
;
function parseStyle(style) {
    if (!style)
        return null;
    var obj = {};
    style.split(';')
        .map(function (p) { return p.trim(); })
        .map(function (p) { return p.split(':'); })
        .map(function (p) { return ({ key: p[0], value: p.slice(1).join(':') }); })
        .forEach(function (p) { return obj[p.key] = p.value; });
    return obj;
}


/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_unprefix_prop_name__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_copyProps__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_object__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_card_mixin__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__card_body__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__card_header__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__card_footer__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__card_img__ = __webpack_require__(105);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














var cardImgProps = Object(__WEBPACK_IMPORTED_MODULE_3__utils_copyProps__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__card_img__["b" /* props */], __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__["a" /* default */].bind(null, 'img'));
cardImgProps.imgSrc.required = false;

var props = Object(__WEBPACK_IMPORTED_MODULE_5__utils_object__["a" /* assign */])({}, __WEBPACK_IMPORTED_MODULE_7__card_body__["b" /* props */], __WEBPACK_IMPORTED_MODULE_8__card_header__["b" /* props */], __WEBPACK_IMPORTED_MODULE_9__card_footer__["b" /* props */], cardImgProps, Object(__WEBPACK_IMPORTED_MODULE_3__utils_copyProps__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__mixins_card_mixin__["a" /* default */].props), {
  align: {
    type: String,
    default: null
  },
  noBody: {
    type: Boolean,
    default: false
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots;

    // The order of the conditionals matter.
    // We are building the component markup in order.
    var childNodes = [];
    var $slots = slots();
    var img = props.imgSrc ? h(__WEBPACK_IMPORTED_MODULE_10__card_img__["a" /* default */], {
      props: Object(__WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__["a" /* default */])(cardImgProps, props, __WEBPACK_IMPORTED_MODULE_2__utils_unprefix_prop_name__["a" /* default */].bind(null, 'img'))
    }) : null;

    if (img) {
      // Above the header placement.
      if (props.imgTop || !props.imgBottom) {
        childNodes.push(img);
      }
    }
    if (props.header || $slots.header) {
      childNodes.push(h(__WEBPACK_IMPORTED_MODULE_8__card_header__["a" /* default */], { props: Object(__WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__card_header__["b" /* props */], props) }, $slots.header));
    }
    if (props.noBody) {
      childNodes.push($slots.default);
    } else {
      childNodes.push(h(__WEBPACK_IMPORTED_MODULE_7__card_body__["a" /* default */], { props: Object(__WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__card_body__["b" /* props */], props) }, $slots.default));
    }
    if (props.footer || $slots.footer) {
      childNodes.push(h(__WEBPACK_IMPORTED_MODULE_9__card_footer__["a" /* default */], { props: Object(__WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__card_footer__["b" /* props */], props) }, $slots.footer));
    }
    if (img && props.imgBottom) {
      // Below the footer placement.
      childNodes.push(img);
    }

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'card',
      class: (_class = {}, _defineProperty(_class, 'text-' + props.align, Boolean(props.align)), _defineProperty(_class, 'bg-' + props.bgVariant, Boolean(props.bgVariant)), _defineProperty(_class, 'border-' + props.borderVariant, Boolean(props.borderVariant)), _defineProperty(_class, 'text-' + props.textVariant, Boolean(props.textVariant)), _class)
    }), childNodes);
  }
});

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BreadcrumbAnchor_vue__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11eb070a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BreadcrumbAnchor_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(73)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11eb070a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BreadcrumbAnchor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11eb070a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BreadcrumbAnchor_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11eb070a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BreadcrumbAnchor_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(74);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("1c49cdf8", content, true, {});

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".breadcrumb-anchor[data-v-11eb070a]:before{display:block;content:\" \";margin-top:-56px;height:56px;visibility:hidden}", ""]);

// exports


/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-anchor",attrs:{"id":_vm.safeId,"breadcrumb-title":_vm.title,"breadcrumb-link-class":_vm.linkClass}},[_vm._t("default",[_c('h2',[_vm._v(_vm._s(_vm.title))])])],2)}
var staticRenderFns = []


/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8baffb9c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(98)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8baffb9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8baffb9c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8baffb9c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c275f8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c275f8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c275f8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",[(!_vm.localStart)?_c('p',[_vm._v("Registration is not yet open. Please check back later.")]):(_vm.localStart.isAfter(_vm.now))?_c('p',[_vm._v("Registration opens "+_vm._s(_vm.localStart.format(_vm.dateFormat)))]):(_vm.registered)?_c('div',[_c('p',[_vm._v("You are already registered!")]),_vm._v(" "),_vm._m(0)]):(_vm.full)?_c('div',[_c('p',[_vm._v("Registration is full!")]),_vm._v(" "),_vm._m(1)]):_c('div',[_c('p',[_vm._v("Registration is open!")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.registerUrl}},[_vm._v("Register Now")])])])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n                To change your registration, please contact Marie Butler at "),_c('a',{attrs:{"href":"mailto:marie@richardsinstitute.org"}},[_vm._v("marie@richardsinstitute.org")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n                To be placed on the wait list, please contact Marie Butler at "),_c('a',{attrs:{"href":"mailto:marie@richardsinstitute.org"}},[_vm._v("marie@richardsinstitute.org")])])}]


/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__ = __webpack_require__(42);




var props = Object(__WEBPACK_IMPORTED_MODULE_1__utils_object__["a" /* assign */])({}, __WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__["b" /* props */], {
  text: {
    type: String,
    default: null
  },
  href: {
    type: String,
    default: null
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h('li', Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'breadcrumb-item',
      class: { active: props.active },
      attrs: { role: 'presentation' }
    }), [h(__WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__["a" /* default */], { props: props }, children)]);
  }
});

/***/ }),

/***/ 910:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Cover_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_AlertList_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_layout_row__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_components_layout_col__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Card_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_es_components_card_card_group__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_Coordinators_vue__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_Rate_vue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Components_BingMap_vue__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Components_BreadcrumbAnchor_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Components_Register_vue__ = __webpack_require__(87);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};












var WinterCourseYear = /** @class */ (function (_super) {
    __extends(WinterCourseYear, _super);
    function WinterCourseYear() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Object })
    ], WinterCourseYear.prototype, "general", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Object })
    ], WinterCourseYear.prototype, "banner", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Object })
    ], WinterCourseYear.prototype, "socialMedia", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Array, default: function () { return []; } })
    ], WinterCourseYear.prototype, "information", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Object })
    ], WinterCourseYear.prototype, "universityCredit", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Object })
    ], WinterCourseYear.prototype, "tuition", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], WinterCourseYear.prototype, "generalEmail", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], WinterCourseYear.prototype, "generalPhoneNumber", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Array, default: function () { return []; } })
    ], WinterCourseYear.prototype, "courses", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String, required: true })
    ], WinterCourseYear.prototype, "registerUrl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], WinterCourseYear.prototype, "registrationUrl", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Boolean, default: false })
    ], WinterCourseYear.prototype, "registered", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: String })
    ], WinterCourseYear.prototype, "registrationStart", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ type: Array, default: function () { return []; } })
    ], WinterCourseYear.prototype, "resources", void 0);
    WinterCourseYear = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({
            name: "WinterCourseYear",
            components: {
                Cover: __WEBPACK_IMPORTED_MODULE_1__Components_Cover_vue__["a" /* default */],
                AlertList: __WEBPACK_IMPORTED_MODULE_2__Components_AlertList_vue__["a" /* default */],
                "b-card-group": __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_es_components_card_card_group__["a" /* default */],
                Card: __WEBPACK_IMPORTED_MODULE_5__Components_Card_vue__["a" /* default */],
                Coordinators: __WEBPACK_IMPORTED_MODULE_7__Components_Coordinators_vue__["a" /* default */],
                Rate: __WEBPACK_IMPORTED_MODULE_8__Components_Rate_vue__["a" /* default */],
                BingMap: __WEBPACK_IMPORTED_MODULE_9__Components_BingMap_vue__["a" /* default */],
                BreadcrumbAnchor: __WEBPACK_IMPORTED_MODULE_10__Components_BreadcrumbAnchor_vue__["a" /* default */],
                Register: __WEBPACK_IMPORTED_MODULE_11__Components_Register_vue__["a" /* default */],
                "b-row": __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_es_components_layout_row__["a" /* default */],
                "b-col": __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_es_components_layout_col__["a" /* default */]
            }
        })
    ], WinterCourseYear);
    return WinterCourseYear;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (WinterCourseYear);
;


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(99);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("0c3af654", content, true, {});

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".card-header h4[data-v-8baffb9c]{margin-bottom:0}.card-header h4.has-badge[data-v-8baffb9c]{display:inline-block}.card-body[data-v-8baffb9c] p:last-child{margin-bottom:0}li .card[data-v-8baffb9c]{margin-bottom:.75rem}li:last-child .card[data-v-8baffb9c]{margin-bottom:unset}", ""]);

// exports


/***/ })

},[1296]);


// WEBPACK FOOTER //
// WinterCourseYear/Index.573be615cd95d5a64250.js